<template>
  <v-app style="background-color: lightgray;">
    <AutoLogout></AutoLogout>
    <v-toolbar class="col-xs-12" app height="45">
      <div>
        <a @click="backToPrevPage()">
          <v-icon style="font-size:30px;padding-left:2.5px;padding-top:2px;">arrow_back</v-icon>
        </a>
      </div>

      <v-spacer></v-spacer>
      <v-toolbar-title
        v-if="successLogin && backEndAddOrdMode == false"
        class="headline"
        style="min-width:30px;"
      >
        <v-menu offset-y>
          <a slot="activator">
            <img
              src="./assets/loginIcon.png"
              alt="logo"
              class="navImgTitle"
              @click="getUserCurrentInfo()"
            />
          </a>

          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <img src="./assets/sirPos.png" />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{clientDisplayName}}</v-list-tile-title>
                <v-list-tile-sub-title v-if="foodCourtMode" style="margin-top:5px;">Balance Amount:</v-list-tile-sub-title>
                <v-list-tile-sub-title
                  v-if="foodCourtMode"
                  style="color:black;"
                >{{userCurrentBalance | currency(userCurrentBalance)}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider style="margin-left:15px;margin-right:15px;margin-bottom:0px;"></v-divider>
            <li style="margin:15px;width:100%;" @click="viewPurchaseHistory()">
              <button>Purchase History</button>
            </li>
            <li style="margin:15px;color:red;width:100%;" @click="logOutUser()">
              <button>Logout</button>
            </li>
          </v-list>
        </v-menu>
      </v-toolbar-title>
      <!-- <v-toolbar-title
        v-if="!successLogin && needLoginAndPay"
        class="headline"
        style="min-width:40px;"
        @click="goLogin()"
      >
        <button class="btn">Login</button>
      </v-toolbar-title>-->
      <v-toolbar-title v-if="backEndAddOrdMode" style="width:45px;" @click="backToBackEndOrd()">
        <button style="width:30px;border-radius:5px;background-color:red;color:white" class="btn">X</button>
      </v-toolbar-title>
    </v-toolbar>

    <v-container style="padding:10px;">
      <v-layout text-xs-left wrap style="margin-top:40px;">
        <div class="col-xs-12" style="width:100%;">
          <div class="col-xs-12" style="text-align: center;">
            <h2 class="col-xs-12" style="margin:0px">Shopping Cart</h2>
          </div>

          <div v-if="!emptySCart" class="col-xs-12">
            <div class="list-group-item clearfix" style="padding:10px;">
              <v-container style="padding:0px;">
                <h3 class="TrnHdr">Order Type: {{schdTypeName}}</h3>
                <h3 v-if="foodCourtMode == false" class="TrnHdr">Order Date: {{clientsSltDate}}</h3>
                <h3
                  v-if="uTableNum != '' && (schdType == 1 || schdType == 4)"
                  class="TrnHdr"
                >Table Number: {{uTableNum}}</h3>
              </v-container>

              <!-- <v-container v-if="needLoadSearch == 'false'" style="padding:0px;display: flex;">
                <h4 class="TrnHdrTbNum">Table Number:</h4>
                <input
                  v-model="uTableNum"
                  style="width:100%;"
                  type="text"
                  class="form-control searchBar TrnHdrTbNumInput"
                  name="uTableNum"
                  placeholder="Table Number"
                  @input="uTableNum = $event.target.value"
                />
              </v-container>
              <v-container v-if="needLoadSearch == 'false'" style="padding:0px;display: flex;">
                <h4 class="TrnHdrTbNum">Tel No:</h4>
                <input
                  v-model="uTelNumInput"
                  style="width:100%;"
                  type="number"
                  class="form-control searchBar TrnHdrTbNumInput"
                  name="uTelNumInput"
                  placeholder="Tel No"
                  @input="uTelNumInput = $event.target.value"
                />
              </v-container>-->
            </div>
          </div>

          <div class="col-xs-12">
            <a
              v-for="(x, i) of ListOfSCartItem"
              :key="x.ID"
              class="list-group-item clearfix"
              style="padding:10px;"
            >
              <div v-if="!emptySCart" class="col-xs-12 pull-left" style="padding: 0;">
                <button
                  class="btn btn-danger deleteBtn"
                  style="padding: 0px;"
                  @click="deleteCartItem(i)"
                >X</button>
                <div row>
                  <div style="max-width:95%;">
                    <img
                      :src="x.itemSmallImg"
                      style="width:100%;height:auto;max-width:80px;float: left;padding-right:10px;"
                      @click="editItemDetail(x, i)"
                    />
                    <h4
                      class="list-group-item-text"
                      style="font-size:18px;margin-left:80px;"
                      @click="editItemDetail(x, i)"
                    >{{ x.name }}</h4>
                    <h4
                      v-if="x.size != '#'"
                      class="list-group-item-text"
                      style="font-size:16px;margin-left:80px;"
                      @click="editItemDetail(x, i)"
                    >{{ x.size }} - RM {{ x.singlePriceWTax }}</h4>
                    <!-- <h4
                      class="list-group-item-text"
                      style="font-size:16px;"
                    >RM {{ x.singlePrice | currency(x.singlePrice)}}</h4>-->
                    <h4
                      v-if="x.prop.length > 0 "
                      class="list-group-item-text"
                      style="font-size:16px;margin-left:80px;"
                      @click="editItemDetail(x, i)"
                    >{{ x.prop | ArrangeTxt(x.prop) }}</h4>
                    <h4 v-if="x.prop.length == 0 " class="list-group-item-text"></h4>
                  </div>

                  <!-- <div style="float: right; min-width:265px;text-align:left;">
                    <h4>Unit Price : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; RM {{ x.singlePrice | currency(x.singlePrice)}}</h4>
                    <h4>Total Price : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; RM {{ x.totalPrice | currency(x.totalPrice)}}</h4>
                  </div>-->

                  <div
                    v-if="x.soldOutItem == false && x.inActiveItem == false && x.priceInvalidItem == false"
                  >
                    <h4
                      class="list-group-item-text"
                      style="font-size:16px;float: right;margin:0px;margin-top:8px;"
                    >RM {{ x.totalPricePerQtyWTax }}</h4>
                  </div>

                  <div v-if="x.soldOutItem" style="float: right;">
                    <h3 style="color:red;margin:0px;font-size:20px;">Sold Out</h3>
                  </div>
                  <div v-if="x.inActiveItem" style="float: right;">
                    <h3 style="color:red;margin:0px;font-size:20px;">Item Inactive</h3>
                  </div>
                  <div v-if="x.priceInvalidItem" style="float: right;">
                    <h3 style="color:red;margin:0px;font-size:20px;">Price Invalid</h3>
                  </div>

                  <div
                    v-if="x.soldOutItem == false && x.inActiveItem == false && x.priceInvalidItem == false"
                    style="float: right;"
                  >
                    <button
                      v-if="x.prcType != 1"
                      class="btn btn-danger"
                      style="min-width: 32px;"
                      type="submit"
                      @click="sub(i)"
                    >-</button>
                    <button class="btn iPrice" style="min-width: 32px;padding:0px;" type="number">
                      <input
                        v-model="x.qty"
                        type="tel"
                        style="width:40px;padding:5px;"
                        class="form-control"
                        name="qty"
                        autocomplete="nope"
                        @input="x.qty = $event.target.value.replace(/[^0-9]/g,'')"
                        @change="chgQty(x.qty,i)"
                      />
                    </button>
                    <button
                      v-if="x.prcType == 1"
                      class="btn"
                      style="margin-right: 5px;min-width: 32px;"
                    ></button>
                    <button
                      v-if="x.prcType != 1"
                      class="btn btn-success"
                      style="margin-right: 20px;min-width: 32px;"
                      type="submit"
                      @click="add(i)"
                    >+</button>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div v-if="!emptySCart" class="col-xs-12" style="margin-bottom: 30px;">
            <!-- <hr /> -->
            <v-card style="margin:1px;margin-top:0px;padding-top:20px;">
              <v-container style="max-width:30%;text-align:left;float:left;padding:0px;bottom:0%;">
                <h5
                  class="list-group-item-text smallFontSize"
                  style="margin-left:10px;"
                >{{totalQty}} Items</h5>
              </v-container>

              <v-container style="max-width:60%;margin-right:0px;text-align:left;padding:0px;">
                <h5 class="list-group-item-text smallFontSize">
                  Sub Total :
                  <span class="spanTxtStyle">{{ subtotal | currency(subtotal)}}</span>
                  <span style="float:right;min-width:5%;">RM</span>
                </h5>
                <h5 v-if="taxAmt != 0" class="list-group-item-text smallFontSize">
                  Tax :
                  <span class="spanTxtStyle">{{ taxAmt | currency(taxAmt)}}</span>
                  <span style="float:right;min-width:5%;">RM</span>
                </h5>
                <h5 v-if="svcAmt != 0" class="list-group-item-text smallFontSize">
                  Service Charge :
                  <span class="spanTxtStyle">{{ svcAmt | currency(svcAmt)}}</span>
                  <span style="float:right;min-width:5%;">RM</span>
                </h5>
                <h5 v-if="DeliveryCharges != 0" class="list-group-item-text smallFontSize">
                  Delivery Charges :
                  <span
                    class="spanTxtStyle"
                  >{{ DeliveryCharges | currency(DeliveryCharges)}}</span>
                  <span style="float:right;min-width:5%;">RM</span>
                </h5>
                <hr style="border: solid 0.5px;" />
                <h5 class="list-group-item-text smallFontSize">
                  Grand Amount :
                  <span class="spanTxtStyle">{{ totalAmt | currency(totalAmt)}}</span>
                  <span style="float:right;min-width:5%;">RM</span>
                </h5>
                <h5 v-if="rounding != 0" class="list-group-item-text smallFontSize">
                  Rounding :
                  <span class="spanTxtStyle">{{ rounding | currency(rounding)}}</span>
                  <span style="float:right;min-width:5%;">RM</span>
                </h5>
                <hr style="border: solid 0.5px;" />
                <h5 class="list-group-item-text smallFontSize">
                  Net Grand Total :
                  <span class="spanTxtStyle">{{ roundAmt | currency(roundAmt)}}</span>
                  <span style="float:right;min-width:5%;">RM</span>
                </h5>
                <h5
                  v-if="heNeedPayment && (depositePercent != 100 && depositePercent !=0)"
                  style="color:red;font-size:15px;"
                  class="list-group-item-text smallFontSize"
                >**Min Deposit : RM &nbsp;{{ minPayAmt | currency(minPayAmt)}}</h5>
                <h5
                  v-if="heNeedPayment && (depositePercent != 100 && depositePercent !=0)"
                  class="list-group-item-text smallFontSize"
                >
                  Deposit : RM
                  <input
                    v-model="deposit"
                    type="number"
                    min="1"
                    autocomplete="nope"
                    style="border: solid 1px; max-width:80px;margin-left:0px;float:right;"
                    @input="deposit = $event.target.value"
                  />
                </h5>
                <h5
                  v-if="depositError"
                  class="smallFontSize"
                  style="color:red;"
                >**Deposit amount does not meet the requirements</h5>
                <h5
                  v-if="depositError2"
                  class="smallFontSize"
                  style="color:red;"
                >**The Deposit amount exceeds the Total Amount</h5>
                <hr style="border: solid 0.5px;margin-bottom:10px;" />
                <hr style="border: solid 0.5px;margin-top:10px;" />

                <div v-if="heNeedPayment && (depositePercent != 100 && depositePercent !=0)">
                  <h5 v-if="depositePercent != 0">Payment Option:</h5>
                  <h4
                    v-if="depositePercent != 0"
                    class="smallFontSize"
                  >**If the amount exceeds RM {{depositeFull}}, you only need to pay a {{depositePercent}}% deposit.</h4>
                </div>
              </v-container>
              <h5
                v-if="notLoadSearchTbNumError"
                class="smallFontSize"
                style="color:red;padding:10px;"
              >**Table Number field is required</h5>
              <h5
                v-if="notLoadSearchTelError"
                class="smallFontSize"
                style="color:red;padding:10px;"
              >**Telephone Number field is required</h5>
              <h5
                v-if="schdType == 3 && deliveryMsg.length>0"
                class="smallFontSize"
                style="color:red;padding:10px;white-space: pre-wrap;"
              >{{deliveryMsg}}</h5>
              <br v-if="schdType != 3" />
              <!-- @click="checkoutBtn(deposit,uTableNum)" -->
              <div>
                <button
                  v-if="errorItemFoundInCart == false"
                  class="btn addCartBtn"
                  style="width:100%; height:45px; padding:0px; font-size: 20px;"
                  @click="checkoutBtn(deposit)"
                >Check Out</button>
                <button
                  v-if="errorItemFoundInCart"
                  class="btn addCartBtn"
                  style="width:100%; height:45px; padding:0px; font-size: 20px;"
                  disabled
                >Check Out</button>
              </div>
            </v-card>
          </div>
          <div
            v-if="emptySCart"
            class="list-group-item"
            style="text-align: center;margin-top: 20px;"
          >
            <span>
              <h2>Your shopping cart is empty! Let's go shopping!</h2>
            </span>
            <button class="btn addCartBtn" style="width:80%;" @click="backToPrevPage()">Back to Shop</button>
          </div>
        </div>
      </v-layout>

      <v-layout class="text-xs-center">
        <v-dialog v-model="deleteItmDialog" persistent width="1000">
          <v-card>
            <v-card-title
              class="headline primary lighten-2"
              primary-title
              style="color: white;"
            >Inform</v-card-title>
            <v-card-text>
              <h3>Are you sure to remove this item?</h3>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="default" flat @click="sureToDlt()">Yes</v-btn>
              <v-btn color="primary" flat @click="deleteItmDialog = false">No</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout class="text-xs-center">
        <v-dialog v-model="cancelRecInfoDialog" persistent width="1000">
          <v-card>
            <v-card-title
              class="headline primary lighten-2"
              primary-title
              style="color: white;"
            >Inform</v-card-title>
            <v-card-text>
              <h3>Are you sure to cancel?</h3>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="default" flat @click="sureTocancelRecInfo()">Yes</v-btn>
              <v-btn color="primary" flat @click="cancelRecInfoDialog = false">No</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout class="text-xs-center">
        <v-dialog v-model="userLoginGetDetailDialog" persistent width="1000">
          <v-card>
            <v-card-title
              class="headline lighten-2"
              style="padding-top: 10px; padding-bottom: 0px;"
            >Login</v-card-title>
            <v-card-text style="padding:10px;">
              <v-container grid-list-md style="padding-top: 0px;padding-bottom: 0px;">
                <v-layout wrap>
                  <v-flex xs12>
                    <h4 class="userProfileTxt">Tel No :</h4>
                    <input
                      v-model="loginUName"
                      class="form-control"
                      name="loginUName"
                      required
                      type="text"
                      @input="loginUName = $event.target.value"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <h4 class="userProfileTxt">Password :</h4>
                    <input
                      v-model="loginUPswd"
                      class="form-control"
                      required
                      type="password"
                      name="loginUPswd"
                      @input="loginUPswd = $event.target.value"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
              <br />
              <span
                v-if="dataTologinError"
                style="padding-left:15px;"
                class="txtClrRed"
              >{{dataTologinErrorMsg}}</span>
              <br v-if="foodCourtMode == false || globalVar.mode == 'normal'" />
              <br v-if="foodCourtMode == false || globalVar.mode == 'normal'" />
              <div v-if="foodCourtMode == false || globalVar.mode == 'normal'" class="vl">
                <span class="vl-innertext">or</span>
              </div>
              <br v-if="foodCourtMode == false || globalVar.mode == 'normal'" />
              <div
                v-if="foodCourtMode == false || globalVar.mode == 'normal'"
                style="text-align: center;"
              >
                <button class="btn btn-info guestTxt" @click="loginAsGuest()">Login As Guest</button>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="default" flat @click="userLoginGetDetailDialog = false">Close</v-btn>
              <v-btn color="primary" flat @click="getUserDataByLogin()">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout class="text-xs-center">
        <v-dialog v-model="orderInfoDialog" persistent width="1000">
          <v-card>
            <v-card-title
              class="headline lighten-2"
              style="padding-top: 10px; padding-bottom: 0px;"
            >Order Info</v-card-title>
            <v-card-text style="padding:10px;">
              <v-container grid-list-md style="padding-top: 0px;padding-bottom: 0px;">
                <v-layout wrap>
                  <v-flex xs12>
                    <h5
                      v-if="foodCourtMode && successLogin"
                      class="userProfileTxt"
                    >Balance Amount: RM {{uBalancePoint | currency(uBalancePoint)}}</h5>
                    <!-- <h5 v-if="realDeposit >0" class="userProfileTxt">
                      <span style="padding-right:20px;">Total Amount</span>
                      : RM {{ realDeposit | currency(realDeposit)}}
                    </h5>
                    <h5 v-if="realDeposit == 0" class="userProfileTxt">
                      <span style="padding-right:20px;">Total Amount</span>
                      : RM {{ roundAmt | currency(roundAmt)}}
                    </h5>-->
                    <h5 class="userProfileTxt">
                      <span style="padding-right:20px;">Total Amount</span>
                      : RM {{ roundAmt | currency(roundAmt)}}
                    </h5>
                    <h5 class="userProfileTxt">
                      <span style="padding-right:20px;">Paid Amount</span>
                      : RM {{ realDeposit | currency(realDeposit)}}
                    </h5>
                    <h5
                      v-if="schdType == 3 && deliveryMsg.length>0"
                      class="smallFontSize"
                      style="color:red;white-space: pre-wrap;"
                    >{{deliveryMsg}}</h5>
                    <div
                      v-if="schdType == 3 && deliveryImgUrl != ''"
                      class="bCol col-xs-12 col-md-12"
                      style="padding: 0px;"
                    >
                      <img class="bImg" style="width:100%;" :src="deliveryImgUrl" />
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
              <span
                v-if="notEnoughBalance != ''"
                style="font-size:18px;"
                class="txtClrRed"
              >** {{notEnoughBalance}}</span>
              <span v-if="errorInfo != ''" class="txtClrRed">Error: {{errorInfo}}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="default" flat @click="cancelRecInfo()">Cancel</v-btn>
              <v-btn color="primary" flat @click="getUserData()">Next</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout class="text-xs-center">
        <v-dialog v-model="userProfileDialog" persistent width="1000">
          <v-card>
            <v-card-title
              class="headline lighten-2"
              style="padding-top: 10px; padding-bottom: 0px;"
            >Receiver's Info</v-card-title>
            <v-card-text style="padding:10px;">
              <v-container grid-list-md style="padding-top: 0px;padding-bottom: 0px;">
                <v-layout wrap>
                  <v-flex xs12>
                    <h5
                      v-if="foodCourtMode && successLogin"
                      class="userProfileTxt"
                    >Balance Amount: RM {{uBalancePoint | currency(uBalancePoint)}}</h5>
                    <!-- <h5 v-if="realDeposit >0" class="userProfileTxt">
                      <span style="padding-right:20px;">Total Amount</span>
                      : RM {{ realDeposit | currency(realDeposit)}}
                    </h5>
                    <h5 v-if="realDeposit == 0" class="userProfileTxt">
                      <span style="padding-right:20px;">Total Amount</span>
                      : RM {{ roundAmt | currency(roundAmt)}}
                    </h5>-->
                    <h5 class="userProfileTxt">
                      <span style="padding-right:20px;">Total Amount</span>
                      : RM {{ roundAmt | currency(roundAmt)}}
                    </h5>
                    <h5 class="userProfileTxt">
                      <span style="padding-right:20px;">Paid Amount</span>
                      : RM {{ realDeposit | currency(realDeposit)}}
                    </h5>
                    <h5
                      v-if="schdType == 3 && deliveryMsg.length>0"
                      class="smallFontSize"
                      style="color:red;white-space: pre-wrap;"
                    >{{deliveryMsg}}</h5>
                    <div
                      v-if="schdType == 3 && deliveryImgUrl != ''"
                      class="bCol col-xs-12 col-md-12"
                      style="padding: 0px;"
                    >
                      <img class="bImg" style="width:100%;" :src="deliveryImgUrl" />
                    </div>
                    <hr style="margin-bottom:0px;" />
                  </v-flex>
                  <v-flex xs12>
                    <h4 class="userProfileTxt">Name: *</h4>
                    <input
                      v-if="foodCourtMode == true && successLogin"
                      v-model="uName"
                      class="form-control"
                      name="uName"
                      type="text"
                      readonly
                    />
                    <input
                      v-if="foodCourtMode == false || !successLogin"
                      v-model="uName"
                      class="form-control"
                      name="uName"
                      required
                      autocomplete="nope"
                      type="text"
                      @input="uName = $event.target.value"
                      @change="checkUserNameData()"
                    />
                    <span v-if="emptNameMsg" class="txtClrRed">**The Name field is required</span>
                  </v-flex>
                  <v-flex xs12>
                    <h4 class="userProfileTxt">Email:</h4>
                    <input
                      v-model="uEmail"
                      class="form-control"
                      label="Email "
                      required
                      autocomplete="nope"
                      type="email"
                      name="uEmail"
                      @input="uEmail = $event.target.value"
                      @change="checkUserEmailData()"
                    />
                    <span
                      v-if="invalidEmail"
                      class="txtClrRed"
                    >**The Email must be a valid email address</span>
                  </v-flex>
                  <v-flex xs12>
                    <h4 class="userProfileTxt">Phone Number: *</h4>
                    <input
                      v-if="foodCourtMode == true && successLogin"
                      v-model="uPhNo"
                      style="width:100%;"
                      class="form-control"
                      label="Phone Number *"
                      type="number"
                      name="uPhNo"
                      readonly
                    />
                    <input
                      v-if="foodCourtMode == false || !successLogin"
                      v-model="uPhNo"
                      style="width:100%;"
                      class="form-control"
                      label="Phone Number *"
                      required
                      type="number"
                      name="uPhNo"
                      autocomplete="nope"
                      @input="uPhNo = $event.target.value"
                      @change="checkUserPhData()"
                    />
                    <span v-if="invalidPhNo" class="txtClrRed">**The Phone number must be a number</span>
                    <span
                      v-if="phNoMin8Chr"
                      class="txtClrRed"
                    >**The Phone number must be at least 8 characters</span>
                  </v-flex>
                  <v-flex v-if="schdType == 1" xs12>
                    <h4 class="userProfileTxt">Pax: *</h4>
                    <input
                      v-model="uPax"
                      style="width:100%;"
                      class="form-control"
                      label="Pax *"
                      required
                      type="number"
                      name="uPax"
                      autocomplete="nope"
                      @input="uPax = $event.target.value"
                      @change="checkUserPaxData()"
                    />
                    <span
                      v-if="invalidPaxNo"
                      class="txtClrRed"
                    >**The Pax number must be a number and must be at least 1.</span>
                  </v-flex>
                  <v-flex xs12>
                    <h4 class="userProfileTxt">Memo:</h4>
                    <input
                      v-model="uMaebmco"
                      class="form-control"
                      label="Memo"
                      type="text"
                      name="uMaebmco"
                      autocomplete="nope"
                      @input="uMaebmco = $event.target.value"
                    />
                  </v-flex>
                  <v-flex v-if="schdType == 3" xs12>
                    <h4 class="userProfileTxt">Address: *</h4>
                    <input
                      v-model="uDelAddress1"
                      class="form-control"
                      label="Address *"
                      required
                      autocomplete="nope"
                      maxlength="60"
                      type="text"
                      name="uDelAddress1"
                      @input="uDelAddress1 = $event.target.value"
                      @change="checkUserDelAddressData()"
                    />
                    <input
                      v-model="uDelAddress2"
                      class="form-control"
                      required
                      autocomplete="nope"
                      maxlength="60"
                      type="text"
                      name="uDelAddress2"
                      @input="uDelAddress2 = $event.target.value"
                    />
                    <input
                      v-model="uDelAddress3"
                      class="form-control"
                      required
                      type="text"
                      maxlength="60"
                      autocomplete="nope"
                      name="uDelAddress3"
                      @input="uDelAddress3 = $event.target.value"
                    />
                    <span
                      v-if="invalidDelAddress"
                      class="txtClrRed"
                    >**The Address field is required.</span>
                  </v-flex>
                  <v-flex v-if="schdType == 3" xs12>
                    <h4 class="userProfileTxt">City:</h4>
                    <input
                      v-model="uDelCity"
                      class="form-control"
                      label="City "
                      maxlength="60"
                      required
                      autocomplete="nope"
                      type="text"
                      name="uDelCity"
                      @input="uDelCity = $event.target.value"
                    />
                    <!-- @change="checkUserDelCityData()" -->
                    <!-- <span v-if="invalidDelCity" class="txtClrRed">**The City field is required.</span> -->
                  </v-flex>
                  <v-flex v-if="schdType == 3" xs12>
                    <h4 class="userProfileTxt">Postcode:</h4>
                    <input
                      v-model="uDelPostcode"
                      class="form-control"
                      maxlength="60"
                      autocomplete="nope"
                      label="Postcode "
                      required
                      type="text"
                      name="uDelPostcode"
                      @input="uDelPostcode = $event.target.value"
                    />
                    <!-- @change="checkUserDelPostcodeData()"
                    <span
                      v-if="invalidDelPostcode"
                      class="txtClrRed"
                    >**The Postcode field is required.</span>-->
                  </v-flex>
                  <v-flex v-if="schdType == 3" xs12>
                    <h4 class="userProfileTxt">State:</h4>
                    <input
                      v-model="uDelState"
                      class="form-control"
                      label="State "
                      maxlength="60"
                      autocomplete="nope"
                      required
                      type="text"
                      name="uDelState"
                      @input="uDelState = $event.target.value"
                    />
                    <!-- @change="checkUserDelStateData()"
                    <span v-if="invalidDelState" class="txtClrRed">**The State field is required.</span>-->
                  </v-flex>
                  <v-flex v-if="schdType == 3" xs12>
                    <h4 class="userProfileTxt">Country :</h4>
                    <input
                      v-model="uDelCountryN"
                      class="form-control"
                      autocomplete="nope"
                      label="Country Name "
                      maxlength="60"
                      required
                      type="text"
                      name="uDelCountryN"
                      @input="uDelCountryN = $event.target.value"
                    />
                    <!-- @change="checkUserDelCountryNameData()"
                    <span v-if="invalidDelCountryN" class="txtClrRed">**The State field is required.</span>-->
                  </v-flex>
                  <v-flex v-if="foodCourtMode == false " xs12>
                    <h4 v-if="schdType != 4" class="userProfileTxt">Time:</h4>
                    <!-- <button
                      v-if="sltNow"
                      class="btn btn-primary"
                      style="margin-right:10px;min-width:95px;"
                      @click="checkTimeStatus('Now')"
                    >Now</button>
                    <button
                      class="btn btn-primary"
                      style="margin-right:10px;min-width:95px;"
                      @click="checkTimeStatus('Later')"
                    >Pick a time</button>-->
                    <!-- <div v-if="sltedTimeStatus === 'Now'">
                      <h3 style="margin-bottom:30px;">{{ timeStatusToday}}</h3>
                    </div>-->
                    <!-- TimePicker -->
                    <!-- v-if="sltedTimeStatus === 'Later'" -->
                    <div v-if="schdType != 4">
                      <v-flex xs11 sm5>
                        <v-dialog
                          ref="dialog"
                          v-model="timePickerMoal"
                          :return-value.sync="time"
                          persistent
                          lazy
                          full-width
                          width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            v-model="time"
                            label="Picker a Time"
                            prepend-icon="access_time"
                            readonly
                            scrollable
                          ></v-text-field>
                          <v-time-picker
                            v-if="timePickerMoal"
                            v-model="time"
                            full-width
                            format="24hr"
                            scrollable
                            :min="ssnTimeFrom"
                            :max="ssnTimeTo"
                            @change="checkUserTimePicker()"
                          >
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="timePickerMoal = false">Cancel</v-btn>
                            <v-btn flat color="primary" @click="$refs.dialog.save(time)">OK</v-btn>
                          </v-time-picker>
                        </v-dialog>
                      </v-flex>
                    </div>
                    <div v-if="invalidTime" class="txtClrRed">**Pick a valid time</div>
                  </v-flex>
                </v-layout>
              </v-container>
              <p style="margin:0px;">*Required field</p>
              <span
                v-if="notEnoughBalance != ''"
                style="font-size:18px;"
                class="txtClrRed"
              >** {{notEnoughBalance}}</span>
              <span v-if="errorInfo != ''" class="txtClrRed">Error: {{errorInfo}}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="default" flat @click="cancelRecInfo()">Cancel</v-btn>
              <v-btn color="primary" flat @click="getUserData()">Next</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout class="text-xs-center">
        <v-dialog v-model="loadingDialog" persistent width="1000">
          <v-card height="200">
            <v-card-text>
              <br />
              <v-btn color="primary" style="float:right;" @click="closeLoadingDialog()">X</v-btn>
              <v-layout row wrap align-center>
                <v-progress-circular
                  :size="100"
                  :width="8"
                  color="primary"
                  indeterminate
                  class="progress-circular"
                ></v-progress-circular>
              </v-layout>
              <div>
                <h3 class="loadingMsg">In progress, please wait a moment.</h3>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout class="text-xs-center">
        <v-dialog v-model="paymentStatusDialog" persistent width="1000">
          <v-card>
            <v-card-title
              class="headline primary lighten-2"
              color="primary-title"
              style="color: white;"
            >Inform</v-card-title>
            <v-card-text>
              <h2>{{ paymentStatus }}</h2>
              <h3>{{ paymentStatus2 }}</h3>
              <!-- <h3 v-if="paymentStatus == 'Successful payment'">{{ paymentStatus3 }}</h3> -->
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div v-if="paymentStatusCloseOnly">
                <v-btn color="primary" flat @click="closePaymentWeb()">Ok</v-btn>
              </div>
              <div v-if="!paymentStatusCloseOnly">
                <div v-if="noNeedPaymentStatusCloseOnly">
                  <v-btn color="primary" flat @click="closeNoNeedPaymentWeb()">Okay</v-btn>
                </div>
                <div v-if="noNeedPaymentStatusCloseOnly==false">
                  <v-btn color="default" flat @click="closePaymentWeb()">Cancel</v-btn>
                  <v-btn color="primary" flat @click="retry()">Retry</v-btn>
                </div>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <VersionDialog v-if="versionError"></VersionDialog>
    </v-container>
  </v-app>
</template>

<script>
import JS from './JsonService'
import JK, { enumEOrder_MchOption } from './JsonKey.js'
import globalVar from './GlobalVar.js'
import VersionDialog from '../src/VersionNotMatchDialog'
import AutoLogout from './AutoLogout'

export default {
  components: {
    VersionDialog,
    AutoLogout
  },
  filters: {
    currency(amount) {
      const amt = Number(amount)
      return amt.toFixed(2)
    },
    ArrangeTxt(txtArray) {
      var txtAry = String(txtArray)
      // txtAry.replace('"', '')
      txtAry = txtAry.replace(/[,]/g, ', ')
      // console.log(txtAry)
      return txtAry
    }
  },
  data() {
    return {
      needLoginAndPay: false,
      foundErrorItem: [],
      successLogin: false,
      clientDisplayName: '',
      cartItem: [],
      ListOfSCartItem: [],
      emptySCart: false,
      totalQty: 0,
      subtotal: 0,
      minPayAmt: 0,
      paymentAmt: 0,
      taxAmt: 0,
      svcAmt: 0,
      totalAmt: 0,
      rounding: 0,
      roundAmt: 0,
      TaxPercent: 0,
      SvcPercent: 0,
      deleteItmDialog: false,
      searchedData: [],
      OrdTrnDtlList: [],
      userProfileDialog: false,
      orderInfoDialog: false,
      ScanOrderMustEnterInfo: true,
      uBalancePoint: 0,
      uName: '',
      uEmail: '',
      uPhNo: '',
      uPax: 0,
      uMaebmco: '',
      emptNameMsg: false,
      invalidEmail: false,
      invalidPhNo: false,
      phNoMin8Chr: false,
      invalidPaxNo: false,
      timePickerMoal: false,
      invalidTime: false,
      ssnTimeFrom: '',
      ssnTimeTo: '',
      time: '',
      dateAndTime: '',
      sltedTimeStatus: '',
      timeStatusToday: '',
      tranNum: '',
      paymentURL: '',
      paymentWeb: null,
      timer: null,
      paymentStatusDialog: false,
      paymentStatus: '',
      paymentStatus2: '',
      paymentStatus3: '',
      paymentStatusCloseOnly: false,
      noNeedPaymentStatusCloseOnly: false,
      checkCanceled: false,
      sltNow: true,
      depositeFull: '',
      depositePercent: '',
      schdType: '',
      schdTypeName: '',
      deposit: 0,
      realDeposit: 0,
      depositError: false,
      depositError2: false,
      RefId: 0,
      loadingDialog: false,
      userLoginGetDetailDialog: false,
      loginUPswd: '',
      loginUName: '',
      dataTologinError: false,
      dataTologinErrorMsg: '',
      userIdFromServer: 0,
      hasLoginUser: false,
      heNeedPayment: true,
      listOfProp: [],
      editProp: [],
      propList: [],
      shopCartItemPropList: [],
      selectedPropDetail: [],
      propNameList: [],
      svcAmtListPerItem: [],
      linePropAddAmt: [],
      linePropAddAmtWTax: [],
      propItemNameListForDesp2: [],
      taxCodePerItem: [],
      taxPercentPerItem: [],
      taxAmtPerItem: [],
      scannedQrLink: '',
      uTableNum: '',
      clientsSltDate: '',
      needLoadSearch: 'true',
      notLoadSearchTbNumError: false,
      notLoadSearchTelError: false,
      backEndAddOrdMode: false,
      uTelNumInput: '',
      foodCourtMode: false,
      paymentType: 0,
      notEnoughBalance: '',
      errorInfo: '',
      userCurrentBalance: 0,
      uDelAddress1: '',
      uDelAddress2: '',
      uDelAddress3: '',
      invalidDelAddress: false,
      uDelCity: '',
      invalidDelCity: false,
      uDelPostcode: '',
      invalidDelPostcode: false,
      uDelState: '',
      invalidDelState: false,
      uDelCountryN: '',
      invalidDelCountryN: false,
      versionError: false,
      errorItemFoundInCart: false,
      deliveryMsg: '',
      deliveryImgUrl: '',
      cancelRecInfoDialog: false,
      DeliveryCharges: 0,
      globalVar: globalVar
    }
  },
  created: function() {
    sessionStorage.setItem('needBackPrevPosition', false)
    const key = 'searchedInfo'
    if (sessionStorage.getItem(key)) {
      const value = sessionStorage.getItem(key)
      this.searchedData = JSON.parse(value)
      console.log('searched Data: ', this.searchedData)
      this.needLoginAndPay = this.needPayment(this.searchedData.ol)
      this.scannedQrLink = this.searchedData.co
      this.uTableNum = this.searchedData.lz
      this.deliveryMsg = this.searchedData.rl
      if (this.searchedData.rm == '' || this.searchedData.rm == null) {
        this.deliveryImgUrl = ''
      } else {
        this.deliveryImgUrl = JS.checkImg(this.searchedData.rm)
      }
      console.log(this.uTableNum)
      if (this.searchedData.le == 0) {
        this.clientsSltDate = new Date().toLocaleDateString()
      } else {
        this.clientsSltDate = new Date(
          this.searchedData.le
        ).toLocaleDateString()
      }
    }

    var backEndMode = sessionStorage.getItem('backEndAddOrd')
    console.log(backEndMode)
    if (
      backEndMode == 'false' ||
      backEndMode == undefined ||
      backEndMode == null
    ) {
      this.backEndAddOrdMode = false
    } else if (backEndMode == 'true') {
      this.backEndAddOrdMode = true
      this.uTableNum = 'TA'
    }

    sessionStorage.getItem('propList')
    const value2 = sessionStorage.getItem('propList')
    this.propList = JSON.parse(value2)
    console.log(this.propList)

    //Check login
    if (sessionStorage.getItem('successLogin')) {
      const value = sessionStorage.getItem('successLogin')
      var status = JSON.parse(value)
      console.log(status)
      this.successLogin = status.successLogin
      this.userIdFromServer = status.clientId
      this.clientDisplayName = status.clientDisplayName
      console.log('login status: ', this.successLogin)
      console.log('login status: ', this.userIdFromServer)
      if (this.userIdFromServer == undefined) {
        this.userIdFromServer = 0
      }
    }

    let foodCourt = this.UseFoodCourtMode(this.searchedData.ol)
    this.foodCourtMode = foodCourt
    this.ScanOrderMustEnterInfo = this.UseScanOrderMustEnterInfo(
      this.searchedData.ol
    )

    this.heNeedPayment = this.needPayment(this.searchedData.ol) //pass ol
    const value3 = sessionStorage.getItem('cart')
    // console.log(value)
    this.cartItem = JSON.parse(value3)
    console.log(this.cartItem)
    if (this.cartItem == undefined || this.cartItem == '') {
      this.emptySCart = true
      console.log('Your cart is empty!')
    } else {
      this.getCartItem(this.cartItem)
    }
    // this.currentTime = mapState('time', ['now'])
    // console.log(this.currentTime)
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    logOutUser() {
      sessionStorage.setItem(
        'loginData',
        JSON.stringify({
          name: '',
          pwd: ''
        })
      )

      sessionStorage.setItem(
        'successLogin',
        JSON.stringify({
          successLogin: false,
          clientDisplayName: '',
          clientMobileNo: '',
          clientAddress: '',
          clientId: '',
          clientEmail: '',
          clientBalancePoint: 0,
          clientAddr1: '',
          clientAddr2: '',
          clientAddr3: '',
          clientCity: '',
          clientPostcode: '',
          clientState: '',
          clientCountryName: ''
        })
      )

      this.successLogin = false

      sessionStorage.clear()
      this.$router.go(0)
    },
    getUserCurrentInfo() {
      this.versionError = false
      const key = 'searchedInfo'
      if (sessionStorage.getItem(key)) {
        const value = sessionStorage.getItem(key)
        // console.log(value)
        this.searchedData = JSON.parse(value)
        // console.log(this.searchedData);
      }

      var version = sessionStorage.getItem('version')
      const url = 'Order/GetUserInfo'
      const parameter = {
        av: version,
        kp: this.searchedData.kp,
        m: this.userIdFromServer
      }
      console.log('parameter: ', parameter)

      JS.request(url, parameter)
        .then(response => {
          console.log('data : ', response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            this.userCurrentBalance = response.data.re

            sessionStorage.setItem(
              'successLogin',
              JSON.stringify({
                successLogin: true,
                clientDisplayName: response.data.ez,
                clientMobileNo: response.data.az,
                clientAddress: response.data.en,
                clientId: response.data.m,
                clientEmail: response.data.ly,
                clientBalancePoint: response.data.re,
                clientAddr1: response.data.rf,
                clientAddr2: response.data.rg,
                clientAddr3: response.data.rh,
                clientCity: response.data.ri,
                clientPostcode: response.data.rj,
                clientState: response.data.rk,
                clientCountryName: response.data.hm
              })
            )
          }
        })
        .catch(error => {
          console.log(error)
          this.versionError = false
        })
    },
    goLogin() {
      this.loginUName = ''
      this.loginUPswd = ''
      this.dataTologinErrorMsg = ''
      this.userLoginGetDetailDialog = true
    },
    getCartItem(data) {
      this.shopCartItemPropList = []
      console.log('data: ', data)
      this.ListOfSCartItem = []
      for (let i = 0; i < data.length; i++) {
        const ListOfSCart = {
          prcType: data[i].prcType,
          desc: data[i].desc,
          itemID: data[i].ID,
          priceID: data[i].PriceID,
          name: data[i].name,
          size: data[i].size,
          qty: data[i].qty,
          prop: data[i].prop,
          propPrice: data[i].propPrice,
          propPriceWTax: data[i].propPriceWTax,
          propTotalPrice: data[i].propTotalPrice,
          propTotalPriceWTax: data[i].propTotalPriceWTax,
          memo: data[i].memo,
          singlePrice: data[i].singlePrice,
          singlePriceWTax: data[i].singlePriceWTax,
          totalPricePerQty: Number(
            Number(data[i].singlePrice) + Number(data[i].propTotalPrice)
          ),
          totalPricePerQtyWTax: Number(
            Number(data[i].singlePriceWTax) + Number(data[i].propTotalPriceWTax)
          ),
          totalPrice: Number(data[i].totalPrice),
          totalPriceWTax: Number(data[i].totalPriceWTax),
          itemSmallImg: data[i].itemSmallImg,
          svcAmt: 0,
          soldOutItem: false,
          inActiveItem: false,
          priceInvalidItem: false
        }
        this.ListOfSCartItem.push(ListOfSCart)
      }
      console.log('Shopping Cart Item data: ', this.ListOfSCartItem)

      // console.log(this.ListOfSCartItem.prop[0])
      for (let i = 0; i < data.length; i++) {
        console.log(data[i].prop)

        this.shopCartItemPropList.push(data[i].prop)
      }
      console.log('Shop Cart Item Prop List:', this.shopCartItemPropList)

      if (this.ListOfSCartItem.length == 0) {
        this.emptySCart = true
        console.log('Your cart is empty!')
      }
      this.getSubtotal()
    },
    selectOrEditProp() {
      for (let i = 0; i < this.shopCartItemPropList.length; i++) {
        if (this.shopCartItemPropList[i] == undefined) {
          this.shopCartItemPropList[i] = ''
        }
        this.ListOfSCartItem[i].prop = this.shopCartItemPropList[i]
      }
      this.editProp = this.shopCartItemPropList
      console.log(this.editProp)
      this.getSubtotal()
    },
    chgQty(qty, index) {
      console.log('Qty', qty)
      console.log('index', index)
      if (qty == 0 || qty == '' || qty == null || qty == undefined) {
        qty = 1
      }

      if (this.ListOfSCartItem[index].qty >= 0) {
        if (this.ListOfSCartItem[index].itemID != null) {
          this.ListOfSCartItem[index].qty = Number(qty)
          this.ListOfSCartItem[index].totalPrice =
            Number(
              Number(this.ListOfSCartItem[index].singlePrice) +
                Number(this.ListOfSCartItem[index].propTotalPrice)
            ) * qty

          this.ListOfSCartItem[index].totalPriceWTax =
            Number(
              Number(this.ListOfSCartItem[index].singlePriceWTax) +
                Number(this.ListOfSCartItem[index].propTotalPriceWTax)
            ) * qty
          //   console.log(this.ListOfSCartItem[index].qty)

          this.getSubtotal()
        }
      }
    },
    add(index) {
      console.log('index', index)
      if (this.ListOfSCartItem[index].qty >= 0) {
        if (this.ListOfSCartItem[index].itemID != null) {
          this.ListOfSCartItem[index].qty =
            Number(this.ListOfSCartItem[index].qty) + 1
          this.ListOfSCartItem[index].totalPrice =
            Number(this.ListOfSCartItem[index].totalPrice) +
            Number(
              Number(this.ListOfSCartItem[index].singlePrice) +
                Number(this.ListOfSCartItem[index].propTotalPrice)
            )

          this.ListOfSCartItem[index].totalPriceWTax =
            Number(this.ListOfSCartItem[index].totalPriceWTax) +
            Number(
              Number(this.ListOfSCartItem[index].singlePriceWTax) +
                Number(this.ListOfSCartItem[index].propTotalPriceWTax)
            )
          //   console.log(this.ListOfSCartItem[index].qty)

          this.getSubtotal()
        }
      }
    },
    sub(index) {
      if (this.ListOfSCartItem[index].itemID != null) {
        if (this.ListOfSCartItem[index].qty > 1) {
          this.ListOfSCartItem[index].qty =
            Number(this.ListOfSCartItem[index].qty) - 1
          this.ListOfSCartItem[index].totalPrice =
            Number(this.ListOfSCartItem[index].totalPrice) -
            Number(
              Number(this.ListOfSCartItem[index].singlePrice) +
                Number(this.ListOfSCartItem[index].propTotalPrice)
            )

          this.ListOfSCartItem[index].totalPriceWTax =
            Number(this.ListOfSCartItem[index].totalPriceWTax) -
            Number(
              Number(this.ListOfSCartItem[index].singlePriceWTax) +
                Number(this.ListOfSCartItem[index].propTotalPriceWTax)
            )
          // console.log(this.ListOfSCartItem[index].qty)
          this.getSubtotal()
        } else {
          this.deleteCartItem(index)
        }
      }
    },
    editItemDetail(val, i) {
      //console.log(val)
      //console.log(i)
      //console.log(this.ListOfSCartItem)
      if (
        this.ListOfSCartItem[i].soldOutItem == false &&
        this.ListOfSCartItem[i].inActiveItem == false &&
        this.ListOfSCartItem[i].priceInvalidItem == false
      ) {
        sessionStorage.setItem('editItemDetailIndex', i)

        if (globalVar.mode == 'normal') {
          this.$router.replace({
            name: 'EditItemDetail',
            params: { itemId: val.itemID }
          })
        } else if (globalVar.mode == 'lite') {
          var mchCd = sessionStorage.getItem('paramMchdCode')
          this.$router.replace({
            name: 'EditItemDetail',
            params: { mchdCode: mchCd, itemId: val.itemID }
          })
        }
      }
    },
    getSubtotal() {
      const key = 'searchedInfo'
      if (sessionStorage.getItem(key)) {
        const value = sessionStorage.getItem(key)
        console.log(value)
        this.searchedData = JSON.parse(value)
        console.log(this.searchedData.ms)
        this.depositeFull = this.searchedData.ms
        console.log(this.searchedData.mt)
        this.depositePercent = this.searchedData.mt
      }

      this.calTotal('')

      //this.subtotal = 0
      this.totalQty = 0
      // this.paymentAmt = 0
      for (let i = 0; i < this.ListOfSCartItem.length; i++) {
        // this.subtotal =
        //   this.subtotal + Number(this.ListOfSCartItem[i].totalPrice)
        this.totalQty = this.totalQty + this.ListOfSCartItem[i].qty
      }
      // console.log('total payment: ', this.subtotal)
      console.log('Shopping Cart Item data(New): ', this.ListOfSCartItem)

      const valueQty = JSON.stringify(this.totalQty)
      sessionStorage.setItem('TotalCartItemQty', valueQty)
      // console.log('total payment: ', this.subtotal)
      console.log('Shopping Cart Item data(New): ', this.ListOfSCartItem)

      this.newListOfSCartItem = []
      for (let i = 0; i < this.ListOfSCartItem.length; i++) {
        const newListOfSCart = {
          prcType: this.ListOfSCartItem[i].prcType,
          desc: this.ListOfSCartItem[i].desc,
          ID: this.ListOfSCartItem[i].itemID,
          PriceID: this.ListOfSCartItem[i].priceID,
          name: this.ListOfSCartItem[i].name,
          size: this.ListOfSCartItem[i].size,
          qty: this.ListOfSCartItem[i].qty,
          prop: this.ListOfSCartItem[i].prop,
          propPrice: this.ListOfSCartItem[i].propPrice,
          propPriceWTax: this.ListOfSCartItem[i].propPriceWTax,
          memo: this.ListOfSCartItem[i].memo,
          singlePrice: this.ListOfSCartItem[i].singlePrice,
          singlePriceWTax: this.ListOfSCartItem[i].singlePriceWTax,
          totalPricePerQty: Number(
            Number(this.ListOfSCartItem[i].singlePrice) +
              Number(this.ListOfSCartItem[i].propTotalPrice)
          ),
          totalPricePerQtyWTax: Number(
            Number(this.ListOfSCartItem[i].singlePriceWTax) +
              Number(this.ListOfSCartItem[i].propTotalPriceWTax)
          ),
          totalPrice: Number(this.ListOfSCartItem[i].totalPrice),
          totalPriceWTax: Number(this.ListOfSCartItem[i].totalPriceWTax),
          propTotalPrice: this.ListOfSCartItem[i].propTotalPrice,
          propTotalPriceWTax: this.ListOfSCartItem[i].propTotalPriceWTax,
          itemSmallImg: this.ListOfSCartItem[i].itemSmallImg,
          soldOutItem: false,
          inActiveItem: false,
          priceInvalidItem: false
        }
        this.newListOfSCartItem.push(newListOfSCart)
      }
      const value = JSON.stringify(this.newListOfSCartItem)
      console.log('value: ', value)
      sessionStorage.setItem('cart', value)
    },
    getSubtotalForCheckOut() {
      const key = 'searchedInfo'
      if (sessionStorage.getItem(key)) {
        const value = sessionStorage.getItem(key)
        console.log(value)
        this.searchedData = JSON.parse(value)
        console.log(this.searchedData.ms)
        this.depositeFull = this.searchedData.ms
        console.log(this.searchedData.mt)
        this.depositePercent = this.searchedData.mt
      }

      this.calTotalForCheckOut()

      //this.subtotal = 0
      // this.paymentAmt = 0
      // for (let i = 0; i < this.ListOfSCartItem.length; i++) {
      //   this.subtotal =
      //     this.subtotal + Number(this.ListOfSCartItem[i].totalPrice)
      // }
      // console.log('total payment: ', this.subtotal)
      console.log('Shopping Cart Item data(New): ', this.ListOfSCartItem)

      this.newListOfSCartItem = []
      for (let i = 0; i < this.ListOfSCartItem.length; i++) {
        const newListOfSCart = {
          prcType: this.ListOfSCartItem[i].prcType,
          desc: this.ListOfSCartItem[i].desc,
          ID: this.ListOfSCartItem[i].itemID,
          PriceID: this.ListOfSCartItem[i].priceID,
          name: this.ListOfSCartItem[i].name,
          size: this.ListOfSCartItem[i].size,
          prop: this.ListOfSCartItem[i].prop,
          propPrice: this.ListOfSCartItem[i].propPrice,
          propPriceWTax: this.ListOfSCartItem[i].propPriceWTax,
          qty: this.ListOfSCartItem[i].qty,
          memo: this.ListOfSCartItem[i].memo,
          singlePrice: this.ListOfSCartItem[i].singlePrice,
          singlePriceWTax: this.ListOfSCartItem[i].singlePriceWTax,
          totalPricePerQty: Number(
            Number(this.ListOfSCartItem[i].singlePrice) +
              Number(this.ListOfSCartItem[i].propTotalPrice)
          ),
          totalPricePerQtyWTax: Number(
            Number(this.ListOfSCartItem[i].singlePriceWTax) +
              Number(this.ListOfSCartItem[i].propTotalPriceWTax)
          ),
          totalPrice: Number(this.ListOfSCartItem[i].totalPrice),
          totalPriceWTax: Number(this.ListOfSCartItem[i].totalPriceWTax),
          propTotalPrice: this.ListOfSCartItem[i].propTotalPrice,
          propTotalPriceWTax: this.ListOfSCartItem[i].propTotalPriceWTax,
          itemSmallImg: this.ListOfSCartItem[i].itemSmallImg,
          soldOutItem: false,
          inActiveItem: false,
          priceInvalidItem: false
        }
        this.newListOfSCartItem.push(newListOfSCart)
      }
      const value = JSON.stringify(this.newListOfSCartItem)
      // console.log('value: ', value)
      sessionStorage.setItem('cart', value)
    },
    deleteCartItem(index) {
      this.deleteItmDialog = true

      this.index = index
    },
    sureToDlt() {
      console.log('index:', this.index)
      this.ListOfSCartItem.splice(this.index, 1)
      this.getSubtotal()

      if (this.ListOfSCartItem.length == 0) {
        this.emptySCart = true
        console.log('Your cart is empty!')
      }
      this.deleteItmDialog = false
    },
    getOrdTrnDtlList() {
      this.OrdTrnDtlList = []
      for (let i = 0; i < this.ListOfSCartItem.length; i++) {
        console.log(this.ListOfSCartItem[i].itemID)
        console.log(this.ListOfSCartItem[i].priceID)
        console.log(i + 1)
        console.log(this.ListOfSCartItem[i].name)
        console.log(this.ListOfSCartItem[i].size)
        console.log(this.ListOfSCartItem[i].prop)
        console.log(this.ListOfSCartItem[i].propPrice)
        console.log(this.ListOfSCartItem[i].qty)
        console.log(this.ListOfSCartItem[i].singlePrice)
        console.log(this.ListOfSCartItem[i].totalPrice)
        console.log(this.svcAmtListPerItem)
        console.log(this.linePropAddAmt)
        console.log(this.propItemNameListForDesp2)

        if (this.ListOfSCartItem[i].size === 'Regular') {
          this.ListOfSCartItem[i].size = '-'
        }

        const OrdList = {
          lk: 0,
          kt: this.ListOfSCartItem[i].itemID,
          ky: this.ListOfSCartItem[i].priceID,
          fk: i + 1,
          ll: this.ListOfSCartItem[i].name,
          lm: this.propItemNameListForDesp2[i],
          ln: this.ListOfSCartItem[i].size, //memo is not used
          lo: this.ListOfSCartItem[i].qty,
          lp: this.ListOfSCartItem[i].singlePrice,
          lq: this.linePropAddAmt[i],
          lr: 0,
          ls: 0,
          lt: this.ListOfSCartItem[i].totalPrice,
          oe: this.SvcPercent,
          oh: this.svcAmtListPerItem[i], //this.ListOfSCartItem[i].svcAmt //==0??
          ou: this.ListOfSCartItem[i].prcType,
          // op: this.getSelectedPropDetail(i)
          ow: this.taxCodePerItem[i],
          od: this.taxPercentPerItem[i],
          og: this.taxAmtPerItem[i],
          ro: this.ListOfSCartItem[i].singlePriceWTax,
          rp: this.linePropAddAmtWTax[i],
          rn: this.ListOfSCartItem[i].totalPriceWTax
        }
        this.OrdTrnDtlList.push(OrdList)
        // console.log(
        //   '0000000000000000000000000000000000000000000000000000000000000000'
        // )
        // console.log(this.ListOfSCartItem[i].totalPrice)
        // console.log(
        //   '0000000000000000000000000000000000000000000000000000000000000000'
        // )

        if (this.ListOfSCartItem[i].size === '-') {
          this.ListOfSCartItem[i].size = 'Regular'
        }
      }

      console.log(this.OrdTrnDtlList)
      console.log(JSON.stringify(this.OrdTrnDtlList))
      return JSON.stringify(this.OrdTrnDtlList)
    },
    getSelectedPropDetail() {
      this.selectedPropDetail = []
      var indexNum = 1
      for (let i = 0; i < this.ListOfSCartItem.length; i++) {
        console.log(
          this.ListOfSCartItem[i].prop + this.ListOfSCartItem[i].propPrice
        )
        console.log(this.ListOfSCartItem[i].propPrice)
        // let propName = this.ListOfSCartItem[i].prop
        // let propPrice = this.ListOfSCartItem[i].propPrice
        // let combine = [propName, propPrice]
        for (let j = 0; j < this.ListOfSCartItem[i].prop.length; j++) {
          console.log(this.ListOfSCartItem[i].prop)
          console.log(this.ListOfSCartItem[i].prop[j])
          const propDetailList = {
            fk: indexNum,
            kt: this.ListOfSCartItem[i].itemID,
            ky: this.ListOfSCartItem[i].priceID,
            ez: this.ListOfSCartItem[i].prop[j],
            lp: this.ListOfSCartItem[i].propPrice[j],
            ro: this.ListOfSCartItem[i].propPriceWTax[j]
          }

          this.selectedPropDetail.push(propDetailList)

          // this.selectedPropDetail.push(this.ListOfSCartItem[i].prop[j])
          // this.selectedPropDetail.push(this.ListOfSCartItem[i].propPrice[j])
        }
        indexNum++
      }

      console.log(this.selectedPropDetail)
      console.log(JSON.stringify(this.selectedPropDetail))
      return JSON.stringify(this.selectedPropDetail)
    },
    checkoutBtn(deposit) {
      console.log(deposit)
      this.realDeposit = deposit
      this.deposit = deposit
      console.log(deposit)
      this.calTotal('checkOutBtn')
    },
    checkOutCheck() {
      this.notEnoughBalance = ''
      this.errorInfo = ''
      // Temporary Close para "tbNum"
      this.notLoadSearchTbNumError = false
      this.notLoadSearchTelError = false
      this.loginUName = ''
      this.loginUPswd = ''
      this.hasLoginUser = false
      this.depositError = false
      this.depositError2 = false
      // this.realDeposit = deposit
      // this.deposit = deposit
      // console.log(deposit)
      this.invalidTime = false
      this.emptNameMsg = false
      this.invalidEmail = false
      this.invalidPhNo = false
      this.phNoMin8Chr = false
      this.invalidPaxNo = false
      this.uBalancePoint = 0
      this.uName = ''
      this.uEmail = ''
      this.uPhNo = ''
      this.uPax = 0
      this.uMaebmco = ''
      this.uDelAddress1 = ''
      this.uDelAddress2 = ''
      this.uDelAddress3 = ''
      this.invalidDelAddress = false
      this.uDelCity = ''
      this.invalidDelCity = false
      this.uDelPostcode = ''
      this.invalidDelPostcode = false
      this.uDelState = ''
      this.invalidDelState = false
      this.uDelCountryN = ''
      this.invalidDelCountryN = false
      this.sltedTimeStatus = ''
      this.time = ''
      this.sltNow = true

      const key = 'searchedInfo'
      if (sessionStorage.getItem(key)) {
        const value = sessionStorage.getItem(key)
        console.log(value)
        this.searchedData = JSON.parse(value)
        // console.log(this.searchedData);
      }

      // console.log(this.searchedData.kp)
      // console.log(this.searchedData.le)
      // console.log(this.subtotal)
      // console.log(this.searchedData.cr)
      // console.log(this.searchedData.cs)
      this.schdType = this.searchedData.mw
      if (this.schdType == 1) {
        this.uPax = 1
      } else {
        this.uPax = 0
      }
      this.checkSchdTypeName(this.schdType)

      this.ssnTimeFrom = this.searchedData.cr.substr(11, 5).toString()
      this.ssnTimeTo = this.searchedData.cs.substr(11, 5).toString()

      var checkCurrentDate = Date.parse(new Date().toISOString().substr(0, 10))
      console.log(checkCurrentDate)

      var currentSsnTimeFrom = new Date()
        .toTimeString()
        .substr(0, 5)
        .toString()

      // console.log(Number(this.ssnTimeFrom.substr(0, 2)))
      // console.log(Number(currentSsnTimeFrom.substr(0, 2)))
      // console.log(Number(this.ssnTimeTo.substr(0, 2)))

      if (
        Number(currentSsnTimeFrom.substr(0, 2)) >=
        Number(this.ssnTimeFrom.substr(0, 2))
      ) {
        if (
          Number(currentSsnTimeFrom.substr(0, 2)) <
          Number(this.ssnTimeTo.substr(0, 2))
        ) {
          if (checkCurrentDate == this.searchedData.le) {
            this.ssnTimeFrom = currentSsnTimeFrom
            this.time = currentSsnTimeFrom
          } else {
            this.time = currentSsnTimeFrom
          }
        } else {
          this.time = ''
        }
      } else {
        this.time = ''
      }

      // if (checkCurrentDate == this.searchedData.le) {
      //   var currentSsnTimeFrom = new Date()
      //     .toTimeString()
      //     .substr(0, 5)
      //     .toString()
      //   console.log(currentSsnTimeFrom)
      //   this.ssnTimeFrom = currentSsnTimeFrom
      // }

      console.log(this.ssnTimeFrom)
      console.log(this.ssnTimeTo)

      let checkTmrDate = Number(new Date()) + Number(1 * 4.32e7)
      console.log(checkTmrDate)

      if (this.searchedData.le > Number(checkTmrDate)) {
        this.sltNow = false
      }

      // Temporary Close
      // if (this.needLoadSearch == 'false' || backEndMode == 'true') {
      //   if (tbNum.trim() == '' || tbNum.trim() == undefined) {
      //     this.notLoadSearchTbNumError = true
      //   } else {
      //     if (
      //       this.uTelNumInput.trim() == '' ||
      //       this.uTelNumInput.trim() == undefined
      //     ) {
      //       this.notLoadSearchTelError = true
      //     } else {
      //       this.uTableNum = tbNum.trim()
      //       this.uPhNo = this.uTelNumInput
      //     }
      //   }
      // }

      var backEndMode = sessionStorage.getItem('backEndAddOrd')
      if (backEndMode != 'true') {
        if (this.needLoadSearch == 'false' || this.needLoadSearch == 'true') {
          if (this.realDeposit <= this.roundAmt) {
            if (this.realDeposit >= this.minPayAmt) {
              let foodCourt = this.UseFoodCourtMode(this.searchedData.ol)
              console.log(foodCourt)
              if (foodCourt) {
                console.log(foodCourt)
                this.foodCourtMode = true

                //check need login & pay
                if (this.heNeedPayment == true) {
                  sessionStorage.getItem('successLogin')
                  const value = sessionStorage.getItem('successLogin')
                  var checkAlreadyLogin = JSON.parse(value)

                  if (checkAlreadyLogin.successLogin == true) {
                    this.checkLoginAndAutoSetData(checkAlreadyLogin)
                    if (
                      this.schdType == 4 &&
                      this.ScanOrderMustEnterInfo == false
                    ) {
                      this.orderInfoDialog = true
                    } else {
                      this.userProfileDialog = true
                    }
                  } else {
                    this.dataTologinError = false
                    this.userLoginGetDetailDialog = true
                  }
                } else {
                  this.realDeposit = 0
                  if (
                    this.schdType == 4 &&
                    this.ScanOrderMustEnterInfo == false
                  ) {
                    this.orderInfoDialog = true
                  } else {
                    this.userProfileDialog = true
                  }
                }
              } else {
                this.foodCourtMode = false
                let needLoginToGetDetail = this.askLoginBeforeCheckout(
                  this.searchedData.ol
                )
                if (needLoginToGetDetail) {
                  sessionStorage.getItem('successLogin')
                  const value = sessionStorage.getItem('successLogin')
                  var checkAlreadyLoginOrNot = JSON.parse(value)
                  // console.log(checkAlreadyLoginOrNot.login)

                  if (checkAlreadyLoginOrNot.successLogin == true) {
                    this.checkLoginAndAutoSetData(checkAlreadyLoginOrNot)
                    if (this.needLoadSearch == 'false') {
                      if (this.notLoadSearchTelError == false) {
                        this.makePayment()
                      }
                    } else {
                      if (
                        this.schdType == 4 &&
                        this.ScanOrderMustEnterInfo == false
                      ) {
                        this.orderInfoDialog = true
                      } else {
                        this.userProfileDialog = true
                      }
                    }

                    this.checkTimeStatus()
                  } else {
                    this.dataTologinError = false
                    this.userLoginGetDetailDialog = true
                  }
                } else {
                  if (this.needLoadSearch == 'false') {
                    if (this.notLoadSearchTelError == false) {
                      this.makePayment()
                    }
                  } else {
                    if (
                      this.schdType == 4 &&
                      this.ScanOrderMustEnterInfo == false
                    ) {
                      this.orderInfoDialog = true
                    } else {
                      this.userProfileDialog = true
                    }
                  }
                  this.checkTimeStatus()
                }
              }
            } else {
              this.depositError = true
            }
          } else {
            this.depositError2 = true
          }
        }
      } else {
        if (this.notLoadSearchTbNumError == false) {
          this.notLoadSearchTelError = false
          this.makePayment()
        }
      }
    },
    checkLoginAndAutoSetData(checkAlreadyLoginOrNot) {
      // get Client DATA from serve and return it back before open the dialog.
      this.dataTologinError = false
      // this.userLoginGetDetailDialog = true
      this.hasLoginUser = true
      this.checkTimeStatus()
      this.userIdFromServer = checkAlreadyLoginOrNot.clientId
      this.uBalancePoint = checkAlreadyLoginOrNot.clientBalancePoint
      this.uName = checkAlreadyLoginOrNot.clientDisplayName
      this.uMaebmco = ''
      this.uPhNo = checkAlreadyLoginOrNot.clientMobileNo
      this.uEmail = checkAlreadyLoginOrNot.clientEmail
      this.uDelAddress1 = checkAlreadyLoginOrNot.clientAddr1
      this.uDelAddress2 = checkAlreadyLoginOrNot.clientAddr2
      this.uDelAddress3 = checkAlreadyLoginOrNot.clientAddr3
      this.uDelCity = checkAlreadyLoginOrNot.clientCity
      this.uDelPostcode = checkAlreadyLoginOrNot.clientPostcode
      this.uDelState = checkAlreadyLoginOrNot.clientState
      this.uDelCountryN = checkAlreadyLoginOrNot.clientCountryName
      if (this.schdType == 1) {
        this.uPax = 1
      } else {
        this.uPax = 0
      }
    },
    checkSchdTypeName(value) {
      console.log(value)
      let btnName = JSON.parse(sessionStorage.getItem('SchdTypeBtnName'))
      if (value == 1) {
        if (btnName.DineIn == '') {
          this.schdTypeName = 'Dine In, Pre-order'
        } else {
          this.schdTypeName = btnName.DineIn
        }
      } else if (value == 2) {
        if (btnName.TakeAway == '') {
          this.schdTypeName = 'Take Away'
        } else {
          this.schdTypeName = btnName.TakeAway
        }
      } else if (value == 3) {
        if (btnName.Delivery == '') {
          this.schdTypeName = 'Delivery'
        } else {
          this.schdTypeName = btnName.Delivery
        }
      } else if (value == 4) {
        if (btnName.ScanOrder == '') {
          this.schdTypeName = 'Dine In, Scan, Order'
        } else {
          this.schdTypeName = btnName.ScanOrder
        }
      } else {
        this.schdTypeName = ''
      }

      // this.needLoadSearch = sessionStorage.getItem('needLoadSearch')
      // if (this.needLoadSearch == 'false') {
      //   this.schdType = 2
      //   this.schdTypeName = 'Take Away'
      // }
      //console.log(this.sltedTypeStatus)
    },
    checkTimeStatus() {
      this.invalidTime = false
      // console.log(value)
      // this.sltedTimeStatus = value

      // if (this.sltedTimeStatus == 'Now') {
      //   this.timeStatusToday = 'Now'
      //   this.invalidTime = false
      // } else if (this.sltedTimeStatus == undefined) {
      //   this.invalidTime = true
      // } else if (this.sltedTimeStatus == 'Later') {
      //   // if (this.time == '') {
      //   //   this.invalidTime = true
      //   // } else {
      //   //   this.invalidTime = false
      //   // }
      // }
    },
    checkUserNameData() {
      // this.emptNameMsg = false
      if (this.uName === '') {
        this.emptNameMsg = true
      } else {
        this.emptNameMsg = false
      }
    },
    checkUserEmailData() {
      // this.invalidEmail = false
      if (this.hasLoginUser == false) {
        if (!this.validEmail(this.uEmail)) {
          this.invalidEmail = true
        } else {
          this.invalidEmail = false
        }
      }
    },
    checkUserPhData() {
      // this.invalidPhNo = false
      if (isNaN(this.uPhNo)) {
        this.invalidPhNo = true
      } else {
        this.invalidPhNo = false
        if (this.invalidPhNo.length < 8) {
          this.phNoMin8Chr = true
        } else {
          this.phNoMin8Chr = false
        }
      }
    },
    checkUserPaxData() {
      console.log(this.uPax)
      if (isNaN(this.uPax)) {
        this.invalidPaxNo = true
      } else {
        if (this.uPax < 1) {
          this.invalidPaxNo = true
        } else {
          this.invalidPaxNo = false
        }
      }
    },
    checkUserDelAddressData() {
      if (
        this.uDelAddress1 == undefined ||
        this.uDelAddress1 == null ||
        this.uDelAddress1.trim() == ''
      ) {
        this.invalidDelAddress = true
      } else {
        this.invalidDelAddress = false
      }
    },
    checkUserDelCityData() {
      if (this.uDelCity.trim() == '') {
        this.invalidDelCity = true
      } else {
        this.invalidDelCity = false
      }
    },
    checkUserDelPostcodeData() {
      if (this.uDelPostcode.trim() == '') {
        this.invalidDelPostcode = true
      } else {
        this.invalidDelPostcode = false
      }
    },
    checkUserDelStateData() {
      if (this.uDelState.trim() == '') {
        this.invalidDelState = true
      } else {
        this.invalidDelState = false
      }
    },
    checkUserDelCountryNameData() {
      if (this.uDelCountryN.trim() == '') {
        this.invalidDelCountryN = true
      } else {
        this.invalidDelCountryN = false
      }
    },
    checkUserTimePicker() {
      if (this.time == '') {
        this.invalidTime = true
      } else {
        this.invalidTime = false
      }
    },

    needPayment(lLevel) {
      console.log(lLevel)
      console.log([enumEOrder_MchOption.NeedPayment])
      console.log((lLevel & [enumEOrder_MchOption.NeedPayment]) != 0)
      return (lLevel & [enumEOrder_MchOption.NeedPayment]) != 0
    },

    askLoginBeforeCheckout(lLevel) {
      console.log((lLevel & [enumEOrder_MchOption.AskLoginBeforeCheckout]) != 0)
      return (lLevel & [enumEOrder_MchOption.AskLoginBeforeCheckout]) != 0
    },
    // UseWalletPayment(lLevel) {
    //   console.log((lLevel & [enumEOrder_MchOption.UseWalletPayment]) != 0)
    //   return (lLevel & [enumEOrder_MchOption.UseWalletPayment]) != 0
    // },
    UseFoodCourtMode(lLevel) {
      console.log((lLevel & [enumEOrder_MchOption.FoodCourtMode]) != 0)
      return (lLevel & [enumEOrder_MchOption.FoodCourtMode]) != 0
    },
    UseScanOrderMustEnterInfo(lLevel) {
      console.log((lLevel & [enumEOrder_MchOption.ScanOrderMustEnterInfo]) != 0)
      return (lLevel & [enumEOrder_MchOption.ScanOrderMustEnterInfo]) != 0
    },
    loginAsGuest() {
      this.hasLoginUser = false
      this.userLoginGetDetailDialog = false
      if (this.needLoadSearch == 'false') {
        this.makePayment()
      } else {
        this.realDeposit = 0
        if (this.schdType == 4 && this.ScanOrderMustEnterInfo == false) {
          this.orderInfoDialog = true
        } else {
          this.userProfileDialog = true
        }
      }
      this.checkTimeStatus()
    },

    getUserDataByLogin() {
      console.log(this.loginUName)
      console.log(this.loginUPswd)
      this.userIdFromServer = 0
      if (this.loginUName != '' && this.loginUName != undefined) {
        if (this.loginUPswd != '' && this.loginUPswd != undefined) {
          this.dataTologinError = false
          this.loadingDialog = true
          this.getLoginDataFromserver()
        } else {
          this.dataTologinError = true
          this.dataTologinErrorMsg = 'The Password field is required'
        }
      } else {
        this.dataTologinError = true
        this.dataTologinErrorMsg = 'The Tel No field is required'
      }
    },
    closeLoadingDialog() {
      this.loadingDialog = false
    },

    getLoginDataFromserver() {
      const key = 'searchedInfo'
      if (sessionStorage.getItem(key)) {
        const value = sessionStorage.getItem(key)
        // console.log(value)
        this.searchedData = JSON.parse(value)
        // console.log(this.searchedData);
      }

      this.versionError = false
      var version = sessionStorage.getItem('version')
      const url = 'Order/Login'
      const parameter = {
        av: version,
        kp: this.searchedData.kp,
        x: this.loginUName,
        on: this.loginUPswd
      }
      console.log('parameter:', parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            this.loadingDialog = false
            if (response.data.m) {
              sessionStorage.setItem(
                'loginData',
                JSON.stringify({
                  name: this.loginUName,
                  pwd: this.loginUPswd
                })
              )
              this.successLogin = true
              sessionStorage.setItem(
                'successLogin',
                JSON.stringify({
                  successLogin: true,
                  clientDisplayName: response.data.ez,
                  clientMobileNo: response.data.az,
                  clientAddress: response.data.en,
                  clientId: response.data.m,
                  clientEmail: response.data.ly,
                  clientBalancePoint: response.data.re,
                  clientAddr1: response.data.rf,
                  clientAddr2: response.data.rg,
                  clientAddr3: response.data.rh,
                  clientCity: response.data.ri,
                  clientPostcode: response.data.rj,
                  clientState: response.data.rk,
                  clientCountryName: response.data.hm
                })
              )
              this.hasLoginUser = true
              this.userLoginGetDetailDialog = false
              this.checkTimeStatus()
              this.userIdFromServer = response.data.m
              this.uBalancePoint = response.data.re
              this.uName = response.data.ez
              this.uMaebmco = ''
              this.uPhNo = response.data.az
              this.uEmail = response.data.ly
              if (this.needLoadSearch == 'false') {
                if (this.foodCourtMode) {
                  if (
                    this.schdType == 4 &&
                    this.ScanOrderMustEnterInfo == false
                  ) {
                    this.orderInfoDialog = true
                  } else {
                    this.userProfileDialog = true
                  }
                } else {
                  this.makePayment()
                }
              } else {
                if (
                  this.schdType == 4 &&
                  this.ScanOrderMustEnterInfo == false
                ) {
                  this.orderInfoDialog = true
                } else {
                  this.userProfileDialog = true
                }
              }
            } else {
              this.successLogin = false
              this.dataTologinError = true
              this.dataTologinErrorMsg = 'Invalid Username Or Password'
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.versionError = false
          this.loadingDialog = false
        })
    },

    getUserData() {
      // console.log(this.uName)
      // console.log(this.uEmail)
      // console.log(this.uPhNo)
      // console.log(this.uMemo)

      console.log(this.timeStatusToday)
      console.log(this.time)

      //Check login
      console.log(this.notEnoughBalance)

      // if (
      //   this.notEnoughBalance == 'Balance Amount Not Enough !!!' ||
      //   (this.notEnoughBalance == '' && this.errorInfo == '')
      // ) {
      //   this.makePayment()
      // } else {
      //   if (sessionStorage.getItem('successLogin')) {
      //     const value = sessionStorage.getItem('successLogin')
      //     var status = JSON.parse(value)
      //     if (status.successLogin) {
      //       this.successLogin = status.successLogin
      //       this.uBalancePoint = status.clientBalancePoint
      //       this.uName = status.clientDisplayName
      //       this.uPhNo = status.clientMobileNo
      //       this.userIdFromServer = status.clientId
      //       this.uEmail = status.clientEmail
      //       this.uMemo = ''
      //       this.uDelAddress1 = status.clientAddr1
      //       this.uDelAddress2 = status.clientAddr2
      //       this.uDelAddress3 = status.clientAddr3
      //       this.uDelCity = status.clientCity
      //       this.uDelPostcode = status.clientPostcode
      //       this.uDelState = status.clientState
      //       this.uDelCountryN = status.clientCountryName
      //       console.log('login status: ', this.successLogin)
      //       this.makePayment()
      //     }
      //   }
      // }

      // if (this.hasLoginUser == true) {
      //   if (this.uEmail === '') {
      //     this.invalidEmail = false
      //   } else {
      //     this.invalidEmail = false
      //   }
      // } else {
      if (this.schdType == 4 && this.ScanOrderMustEnterInfo == false) {
        this.makePayment()
      } else {
        this.invalidEmail = false
        if (!this.validEmail(this.uEmail)) {
          this.invalidEmail = false
        } else {
          this.invalidEmail = false
        }

        if (this.uPhNo === '') {
          this.invalidPhNo = true
        }

        //check user name
        if (this.uName === '') {
          this.emptNameMsg = true
        } else {
          this.emptNameMsg = false
          //check email by login
          if (this.invalidEmail == false) {
            //check phone number
            if (this.uPhNo === '') {
              this.invalidPhNo = true
            } else {
              if (isNaN(this.uPhNo)) {
                this.invalidPhNo = true
              } else {
                if (this.uPhNo.length < 8) {
                  this.phNoMin8Chr = true
                  this.invalidPhNo = false
                } else {
                  this.phNoMin8Chr = false
                  this.invalidPhNo = false
                  if (this.schdType == 2) {
                    this.makePayment()
                  } else {
                    //check Pax
                    if (this.schdType != 1) {
                      if (this.schdType == 3) {
                        this.checkUserDelAddressData()
                        // this.checkUserDelCityData()
                        // this.checkUserDelPostcodeData()
                        // this.checkUserDelStateData()
                        // this.checkUserDelCountryNameData()
                        if (this.invalidDelAddress == false) {
                          this.invalidPaxNo = false
                          this.uPax = 0
                          //check time
                          if (this.time == '') {
                            this.invalidTime = true
                            if (this.foodCourtMode) {
                              this.invalidTime = false
                              this.makePayment()
                            }
                          } else {
                            this.invalidTime = false
                            this.makePayment()
                          }
                        }
                      } else {
                        this.invalidPaxNo = false
                        this.uPax = 0
                        //check time
                        if (this.time == '') {
                          if (this.schdType == 4) {
                            this.invalidTime = false
                            this.makePayment()
                          } else {
                            this.invalidTime = true
                          }
                        } else {
                          this.invalidTime = false
                          this.makePayment()
                        }
                      }
                    } else {
                      if (this.uPax < 1) {
                        this.invalidPaxNo = true
                      } else {
                        this.invalidPaxNo = false
                        //check time
                        if (this.foodCourtMode) {
                          this.invalidTime = false
                          this.makePayment()
                        } else {
                          if (this.time == '') {
                            this.invalidTime = true
                          } else {
                            this.invalidTime = false
                            this.makePayment()
                          }
                        }
                      }
                    }
                  }
                  // if (this.sltedTimeStatus == 'Now') {
                  //   this.invalidTime = false
                  //   this.makePayment()
                  // } else if (this.sltedTimeStatus == 'Later') {
                  //   console.log(this.time)
                  //   if (this.time == '') {
                  //     this.invalidTime = true
                  //   } else {
                  //     this.invalidTime = false
                  //     this.makePayment()
                  //   }
                  // } else {
                  //   this.invalidTime = true
                  // }
                }
              }
            }
          }
        }
      }
      // }
    },
    validEmail: function(email) {
      //eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    backToList() {
      sessionStorage.setItem('needBackPrevPosition', true)

      if (globalVar.mode == 'normal') {
        this.$router.replace('/mainlist')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({ name: 'MainList', params: { mchdCode: mchCd } })
      }
    },
    getTime() {
      // if (this.sltedTimeStatus == 'Now') {
      //   console.log('aaa')
      //   this.dateAndTime =
      //     new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000
      //   // this.dateAndTime = Math.floor(new Date().getTime() / 1000.0)
      //   console.log(this.dateAndTime)
      // }

      // if (this.sltedTimeStatus == 'Later') {
      // console.log(this.time)
      var timeHours = this.time.substring(0, 2)
      var timeSeconds = this.time.substring(3, 5)
      // console.log(timeHours)
      // console.log(timeSeconds)
      // console.log(this.searchedData.le)

      this.dateAndTime =
        Number(this.searchedData.le) +
        Number(timeHours * 3600000) +
        Number(timeSeconds * 60000)
      this.dateAndTime.toString()
      console.log(this.dateAndTime)
      // }
    },
    calTotal(val) {
      const refIdValue = sessionStorage.getItem('haveRefId')
      this.RefId = refIdValue
      console.log(this.RefId)

      const key = 'searchedInfo'
      if (sessionStorage.getItem(key)) {
        const value = sessionStorage.getItem(key)
        console.log(value)
        this.searchedData = JSON.parse(value)
        // console.log(this.searchedData);
      }
      this.schdType = this.searchedData.mw
      this.checkSchdTypeName(this.schdType)

      this.versionError = false
      this.foundErrorItem = []
      var version = sessionStorage.getItem('version')
      const url = 'Order/CalTotal'
      const parameter = {
        av: version,
        kp: this.searchedData.kp,
        co: this.scannedQrLink,
        lz: this.uTableNum,
        lf: 0,
        m: 0,
        ez: '',
        ly: '',
        y: '',
        dy: '',
        ld: 0,
        mw: this.schdType,
        rq: this.subtotal,
        lg: this.totalAmt,
        lh: 0,
        li: 0,
        lj: '',
        od: this.TaxPercent,
        og: this.taxAmt,
        oe: this.SvcPercent,
        oh: this.svcAmt,
        oi: this.rounding,
        oj: this.roundAmt,
        ey: this.RefId,
        rs: this.DeliveryCharges,
        lw: this.getOrdTrnDtlList(),
        op: this.getSelectedPropDetail()
      }
      console.log('parameter:', parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false

            if (response.data.jb) {
              this.foundErrorItem = response.data.jb
              //this.paymentStatusDialog = true
              this.paymentStatus = 'Order Failed'
              this.paymentStatus2 = 'Item Error'
              //this.noNeedPaymentStatusCloseOnly = true
              this.closeNoNeedPaymentWeb()
            } else {
              this.errorItemFoundInCart = false
              for (let k = 0; k < this.ListOfSCartItem.length; k++) {
                this.ListOfSCartItem[k].soldOutItem = false
                this.ListOfSCartItem[k].inActiveItem = false
                this.ListOfSCartItem[k].priceInvalidItem = false
              }
              this.svcAmtListPerItem = []
              this.subtotal = response.data.rq
              this.totalAmt = response.data.lg
              this.TaxPercent = response.data.od
              this.taxAmt = response.data.og
              this.SvcPercent = response.data.oe
              this.svcAmt = response.data.oh
              this.rounding = response.data.oi
              this.roundAmt = response.data.oj
              this.DeliveryCharges = response.data.rs

              for (let i = 0; i < response.data.lw.length; i++) {
                // console.log(response.data.lw[i].oh)
                this.svcAmtListPerItem.push(response.data.lw[i].oh)
                this.linePropAddAmt.push(response.data.lw[i].lq)
                this.linePropAddAmtWTax.push(response.data.lw[i].rp)
                this.propItemNameListForDesp2.push(response.data.lw[i].lm)
                this.taxCodePerItem.push(response.data.lw[i].ow)
                this.taxPercentPerItem.push(response.data.lw[i].od)
                this.taxAmtPerItem.push(response.data.lw[i].og)
                // console.log(this.svcAmtListPerItem)
              }

              if (this.roundAmt < this.depositeFull) {
                this.minPayAmt = this.roundAmt
              } else if (this.roundAmt >= this.depositeFull) {
                this.minPayAmt =
                  this.roundAmt * (this.depositePercent / 100).toFixed(2)
                // this.realDeposit = this.minPayAmt
              }

              this.deposit = this.minPayAmt.toFixed(2)

              // if (this.deposit == 1) {
              //   this.deposit = this.minPayAmt.toFixed(2)
              // } else {
              //   this.deposit = this.minPayAmt.toFixed(2)
              // }
              if (val == 'checkOutBtn') {
                this.checkOutCheck()
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.versionError = false
        })
    },
    calTotalForCheckOut() {
      const refIdValue = sessionStorage.getItem('haveRefId')
      this.RefId = refIdValue
      console.log(this.RefId)

      const key = 'searchedInfo'
      if (sessionStorage.getItem(key)) {
        const value = sessionStorage.getItem(key)
        this.searchedData = JSON.parse(value)
      }
      this.schdType = this.searchedData.mw
      this.checkSchdTypeName(this.schdType)

      this.versionError = false
      this.foundErrorItem = []
      var version = sessionStorage.getItem('version')
      const url = 'Order/CalTotal'
      const parameter = {
        av: version,
        kp: this.searchedData.kp,
        co: this.scannedQrLink,
        lz: this.uTableNum,
        lf: 0,
        m: 0,
        ez: '',
        ly: '',
        y: '',
        dy: '',
        ld: 0,
        mw: this.schdType,
        rq: this.subtotal,
        lg: this.totalAmt,
        lh: 0,
        li: 0,
        lj: '',
        od: this.TaxPercent,
        og: this.taxAmt,
        oe: this.SvcPercent,
        oh: this.svcAmt,
        oi: this.rounding,
        oj: this.roundAmt,
        ey: this.RefId,
        rs: this.DeliveryCharges,
        lw: this.getOrdTrnDtlList(),
        op: this.getSelectedPropDetail()
      }
      console.log('parameter:', parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false

            if (response.data.jb) {
              this.foundErrorItem = response.data.jb
              //this.paymentStatusDialog = true
              this.paymentStatus = 'Order Failed'
              this.paymentStatus2 = 'Item Error'
              //this.noNeedPaymentStatusCloseOnly = true
              this.closeNoNeedPaymentWeb()
            } else {
              this.errorItemFoundInCart = false
              for (let k = 0; k < this.ListOfSCartItem.length; k++) {
                this.ListOfSCartItem[k].soldOutItem = false
                this.ListOfSCartItem[k].inActiveItem = false
                this.ListOfSCartItem[k].priceInvalidItem = false
              }
              this.svcAmtListPerItem = []
              this.subtotal = response.data.rq
              this.totalAmt = response.data.lg
              this.TaxPercent = response.data.od
              this.taxAmt = response.data.og
              this.SvcPercent = response.data.oe
              this.svcAmt = response.data.oh
              this.rounding = response.data.oi
              this.roundAmt = response.data.oj
              this.DeliveryCharges = response.data.rs

              for (let i = 0; i < response.data.lw.length; i++) {
                // console.log(response.data.lw[i].oh)
                this.svcAmtListPerItem.push(response.data.lw[i].oh)
                this.linePropAddAmt.push(response.data.lw[i].lq)
                this.linePropAddAmtWTax.push(response.data.lw[i].rp)
                this.propItemNameListForDesp2.push(response.data.lw[i].lm)
                this.taxCodePerItem.push(response.data.lw[i].ow)
                this.taxPercentPerItem.push(response.data.lw[i].od)
                this.taxAmtPerItem.push(response.data.lw[i].og)
                // console.log(this.svcAmtListPerItem)
              }

              if (this.roundAmt < this.depositeFull) {
                this.minPayAmt = this.roundAmt
              } else if (this.roundAmt >= this.depositeFull) {
                this.minPayAmt =
                  this.roundAmt * (this.depositePercent / 100).toFixed(2)
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.versionError = false
        })
    },
    makePayment() {
      this.notEnoughBalance = ''
      this.errorInfo = ''
      this.userProfileDialog = false
      this.orderInfoDialog = false
      this.loadingDialog = true
      this.paymentType = 0
      console.log(this.uName)
      console.log(this.uEmail)
      console.log(this.uPhNo)
      console.log(this.uMaebmco)
      console.log(this.uPax)

      this.getSubtotalForCheckOut()

      // const key = 'searchedInfo'
      // if (sessionStorage.getItem(key)) {
      //   const value = sessionStorage.getItem(key)
      //   console.log(value)
      //   this.searchedData = JSON.parse(value)
      //   // console.log(this.searchedData);
      // }

      // console.log(this.searchedData.kp)
      // console.log(this.searchedData.le)
      // console.log(this.subtotal)
      // console.log(this.searchedData.cr)
      // console.log(this.searchedData.cs)

      this.getTime()

      if (this.heNeedPayment == false) {
        if (this.foodCourtMode == false) {
          this.realDeposit = 0
        }
      }

      if (this.foodCourtMode == true || this.schdType == 4) {
        this.dateAndTime = 0
      }

      if (this.foodCourtMode == true) {
        console.log(this.heNeedPayment)
        //Set payment type
        if (this.foodCourtMode && this.heNeedPayment && this.hasLoginUser) {
          this.paymentType = 2

          console.log(this.userIdFromServer)
          this.versionError = false
          var version = sessionStorage.getItem('version')
          const url = 'Order/GetUserInfo'
          const parameter = {
            av: version,
            kp: this.searchedData.kp,
            m: this.userIdFromServer
          }
          console.log('parameter:', parameter)
          JS.request(url, parameter)
            .then(response => {
              console.log(response.data)
              if (
                response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
                response.data == 'Version Not Match'
              ) {
                this.versionError = true
              } else {
                this.versionError = false
                this.errorInfo = ''
                if (response.data.re >= this.realDeposit) {
                  this.notEnoughBalance = ''
                  this.checkOutToServe()
                } else {
                  if (this.searchedData.kp == 'p9') {
                    this.notEnoughBalance =
                      '余额不足 !!! 请联系 017- 6086659 （发大财美食热线）'
                  } else {
                    this.notEnoughBalance = 'Balance Amount Not Enough !!!'
                  }
                  this.loadingDialog = false
                  this.uBalancePoint = response.data.re

                  // const checkAlreadyLogin = {
                  //   clientId: response.data.m,
                  //   clientBalancePoint: response.data.re,
                  //   clientDisplayName: response.data.ez,
                  //   clientAddress: this.uMaebmco,
                  //   clientMobileNo: response.data.az,
                  //   clientEmail: this.uEmail
                  // }
                  // console.log(checkAlreadyLogin)
                  // console.log(checkAlreadyLogin.clientId)
                  // this.checkLoginAndAutoSetData(checkAlreadyLogin)
                  if (
                    this.schdType == 4 &&
                    this.ScanOrderMustEnterInfo == false
                  ) {
                    this.orderInfoDialog = true
                  } else {
                    this.userProfileDialog = true
                  }
                }
              }
            })
            .catch(error => {
              console.log(error)
              this.loadingDialog = false
              this.versionError = false
              this.errorInfo = error

              // const checkAlreadyLogin = {
              //   clientId: this.userIdFromServer,
              //   clientBalancePoint: this.uBalancePoint,
              //   clientDisplayName: this.uName,
              //   clientAddress: this.uMemo,
              //   clientMobileNo: this.uPhNo,
              //   clientEmail: this.uEmail
              // }
              // this.checkLoginAndAutoSetData(checkAlreadyLogin)
              if (this.schdType == 4 && this.ScanOrderMustEnterInfo == false) {
                this.orderInfoDialog = true
              } else {
                this.userProfileDialog = true
              }
            })
        } else {
          this.paymentType = 0
          this.realDeposit = 0
          this.checkOutToServe()
        }
      } else {
        this.checkOutToServe()
      }
    },
    checkOutToServe() {
      this.versionError = false
      this.foundErrorItem = []
      var version = sessionStorage.getItem('version')
      const url = 'Order/Checkout'
      const parameter = {
        av: version,
        kp: this.searchedData.kp,
        co: this.scannedQrLink,
        lz: this.uTableNum,
        lf: 0,
        m: this.userIdFromServer,
        ez: this.uName, //User Name
        ly: this.uEmail, //User Email
        y: this.uPhNo, //User Ph no.
        ot: this.uPax, //User Pax
        dy: this.uMaebmco, //memo
        rf: this.uDelAddress1,
        rg: this.uDelAddress2,
        rh: this.uDelAddress3,
        ri: this.uDelCity,
        rj: this.uDelPostcode,
        rk: this.uDelState,
        hm: this.uDelCountryN,
        bl: 0,
        bm: 0,
        ld: this.dateAndTime,
        mw: this.schdType,
        rq: this.subtotal,
        lg: this.totalAmt,
        //lh: this.paymentAmt,
        lh: this.realDeposit,
        li: this.paymentType, //foodCourt = 2
        lj: '',
        od: this.TaxPercent,
        og: this.taxAmt,
        oe: this.SvcPercent,
        oh: this.svcAmt,
        oi: this.rounding,
        oj: this.roundAmt,
        ey: this.RefId,
        rs: this.DeliveryCharges,
        lw: this.getOrdTrnDtlList(),
        op: this.getSelectedPropDetail()

        // <--- Itm inside lw: --->
        // lk = OdrTrnDtlID =0
        // kt = ItemID (shoppinglist)
        // ky = PrcID (shoppinglist)
        // fk = Index;
        // ll = Desp1 //name
        // lm = Desp2 //get from serve
        // ln = Desp3 //size //memo is not used
        // lo = Quantity
        // lp = Price
        // lq = PropAddAmt =0
        // lr = PropMinusAmt =0
        // ls = PropMinusPercent =0
        // lt = LineAmt
        // oe = SvcPercent
        // oh = SvcAmt
      }
      console.log('parameter:', parameter)
      JS.request(url, parameter)
        .then(response => {
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            console.log(response.data)
            //ml = tranID
            //jb
            if (response.data.jb) {
              this.foundErrorItem = response.data.jb
              this.loadingDialog = false
              //this.paymentStatusDialog = true
              this.paymentStatus = 'Order Failed'
              this.paymentStatus2 = 'Item Error'
              //this.noNeedPaymentStatusCloseOnly = true
              this.closeNoNeedPaymentWeb()
            } else if (response.data.ml) {
              this.tranNum = response.data.ml
              this.realDeposit = Number(this.realDeposit).toFixed(2)
              if (this.heNeedPayment) {
                if (this.foodCourtMode == true) {
                  this.loadingDialog = false
                  this.paymentStatusDialog = true
                  this.paymentStatus = 'Order Successful'
                  if (this.realDeposit > 0) {
                    let remainBalance = this.roundAmt - this.realDeposit
                    if (remainBalance > 0) {
                      this.paymentStatus2 =
                        'Thank you for spending RM' +
                        this.realDeposit +
                        ' on shopping. You still need to pay the remaining RM' +
                        remainBalance.toFixed(2) +
                        ' balance.'
                    } else {
                      this.paymentStatus2 =
                        'Thank you for spending RM' +
                        this.realDeposit +
                        ' on shopping. '
                    }
                  } else {
                    this.paymentStatus2 =
                      'Thank you for spending RM' +
                      this.roundAmt.toFixed(2) +
                      ' on shopping. '
                  }
                  this.noNeedPaymentStatusCloseOnly = true
                } else {
                  this.test()
                }
              } else {
                this.loadingDialog = false
                this.paymentStatusDialog = true
                this.paymentStatus = 'Order Successful'
                if (this.realDeposit > 0) {
                  let remainBalance = this.roundAmt - this.realDeposit
                  if (remainBalance > 0) {
                    this.paymentStatus2 =
                      'Thank you for spending RM' +
                      this.realDeposit +
                      ' on shopping. You still need to pay the remaining RM' +
                      remainBalance.toFixed(2) +
                      ' balance.'
                  } else {
                    this.paymentStatus2 =
                      'Thank you for spending RM' +
                      this.realDeposit +
                      ' on shopping. '
                  }
                } else {
                  this.paymentStatus2 =
                    'Thank you for spending RM' +
                    this.roundAmt.toFixed(2) +
                    ' on shopping. '
                }
                this.noNeedPaymentStatusCloseOnly = true
              }
            } else {
              this.loadingDialog = false
              this.paymentStatusDialog = true
              this.paymentStatus = 'Order Failed'
              this.paymentStatus2 = response.data
              this.noNeedPaymentStatusCloseOnly = true
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.versionError = false
        })
    },
    retry() {
      this.paymentWeb.close()
      this.test()
    },
    cancelRecInfo() {
      this.cancelRecInfoDialog = true
    },
    sureTocancelRecInfo() {
      this.cancelRecInfoDialog = false
      this.userProfileDialog = false
      this.orderInfoDialog = false
    },
    test() {
      this.loadingDialog = false
      this.incompletePayment()
      var paymentURL = 'http://payment.postchat.us/' + this.tranNum
      // var paymentURL = 'http://192.168.8.109:8080/' + this.tranNum
      console.log()
      this.paymentWeb = window.open(paymentURL)

      window.addEventListener('message', this.receivedMsg)

      this.timer = setInterval(this.checkIsWindowOpen, 1500)
    },
    receivedMsg(event) {
      console.log('event.data: ', event.data)
      if (event.data === this.tranNum + ' opened') {
        clearInterval(this.timer)
        var paymentURL = 'http://payment.postchat.us/' + this.tranNum
        this.paymentWeb.postMessage(this.tranNum + ' detected', paymentURL)
        console.log('open')
      } else if (event.data === this.tranNum + ' canceled') {
        // Canceled payment
        this.checkCanceled = true
        this.checkIsPaid()
      } else if (
        event.data === this.tranNum + ' completed' ||
        event.data === this.tranNum + ' closed'
      ) {
        this.checkIsPaid()
      }
    },
    checkIsWindowOpen() {
      var paymentURL = 'http://payment.postchat.us/' + this.tranNum
      //console.log('checkIsWindowOpen')
      this.paymentWeb.postMessage(this.tranNum, paymentURL)
    },
    checkIsPaid() {
      this.versionError = false
      var version = sessionStorage.getItem('version')
      let url = 'Payment/GetPaymentInfo'
      let para = {
        [JK.AppVersion]: version,
        [JK.TransNum]: this.tranNum
      }
      JS.request(url, para)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            //lf //ml
            const json = response.data
            if (json.ListOfPayment != null) {
              let payment = json.ListOfPayment[0]
              //let invoiceNo = payment[JK.InvoiceNo]
              //let paymentID = payment[JK.PaymentID]
              let mn = payment[JK.PaymentState]
              //let lh = payment[JK.PaymentAmt]
              if (mn === 'approved') {
                //true
                this.userProfileDialog = false
                this.orderInfoDialog = false
                this.paymentStatusDialog = true
                this.paymentStatus = 'Successful payment'
                this.paymentStatus2 =
                  'Thank you for spending RM' +
                  this.realDeposit +
                  ' on shopping. '
                // this.paymentStatus3 =
                //   'This is your Transaction Number : ' + this.tranNum

                this.paymentStatusCloseOnly = true
              } else {
                //false
                this.incompletePayment()
              }
            } else {
              if (this.checkCanceled == true) {
                //Canceled
                this.userProfileDialog = false
                this.orderInfoDialog = false
                this.paymentStatusDialog = true
                this.paymentStatus = 'Payment was canceled!'
                this.paymentStatus2 =
                  'Press retry button to re-pay the payment.'
                this.paymentStatusCloseOnly = false
              } else {
                // Incompleted OR error
                this.incompletePayment()
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.versionError = false
        })
    },
    incompletePayment() {
      this.userProfileDialog = false
      this.orderInfoDialog = false
      this.paymentStatusDialog = true
      this.paymentStatus = 'Incomplete payment... '
      this.paymentStatus2 = 'Press retry button to re-pay the payment.'
      this.paymentStatusCloseOnly = false
    },
    closePaymentWeb() {
      this.paymentStatusDialog = false
      this.paymentWeb.close()
      if (this.paymentStatus != 'Successful payment') {
        if (this.schdType == 4 && this.ScanOrderMustEnterInfo == false) {
          this.orderInfoDialog = true
        } else {
          this.userProfileDialog = true
        }
        this.checkTimeStatus()
      } else if (this.paymentStatus == 'Successful payment') {
        sessionStorage.setItem('haveRefId', 0)

        if (globalVar.mode == 'normal') {
          this.$router.replace('/')
        } else if (globalVar.mode == 'lite') {
          var mchCd = sessionStorage.getItem('paramMchdCode')
          this.$router.replace({ name: 'Search', params: { mchdCode: mchCd } })
        }
      }
    },
    checkSoldOutItem() {
      console.log(this.foundErrorItem)
      console.log(this.ListOfSCartItem)
      for (let k = 0; k < this.ListOfSCartItem.length; k++) {
        this.ListOfSCartItem[k].soldOutItem = false
        this.ListOfSCartItem[k].inActiveItem = false
        this.ListOfSCartItem[k].priceInvalidItem = false
      }

      this.errorItemFoundInCart = false
      if (this.foundErrorItem.length > 0) {
        for (let i = 0; i < this.foundErrorItem.length; i++) {
          for (let j = 0; j < this.ListOfSCartItem.length; j++) {
            if (this.foundErrorItem[i].kt == this.ListOfSCartItem[j].itemID) {
              if (
                this.foundErrorItem[i].ky == this.ListOfSCartItem[j].priceID
              ) {
                console.log(this.ListOfSCartItem[j].name)
                if (this.foundErrorItem[i].jb == 'sold_out') {
                  this.ListOfSCartItem[j].soldOutItem = true
                  this.ListOfSCartItem[j].inActiveItem = false
                  this.ListOfSCartItem[j].priceInvalidItem = false
                  this.errorItemFoundInCart = true
                } else if (this.foundErrorItem[i].jb == 'item_inactive') {
                  this.ListOfSCartItem[j].soldOutItem = false
                  this.ListOfSCartItem[j].inActiveItem = true
                  this.ListOfSCartItem[j].priceInvalidItem = false
                  this.errorItemFoundInCart = true
                } else if (this.foundErrorItem[i].jb == 'price_invalid') {
                  this.ListOfSCartItem[j].soldOutItem = false
                  this.ListOfSCartItem[j].inActiveItem = false
                  this.ListOfSCartItem[j].priceInvalidItem = true
                  this.errorItemFoundInCart = true
                }
              }
            }
          }
        }
      }
    },
    closeNoNeedPaymentWeb() {
      // 'Successful payment' ==> 'Order Successful'
      this.paymentStatusDialog = false
      // this.paymentWeb.close()
      if (this.paymentStatus != 'Order Successful') {
        // this.userProfileDialog = true
        if (
          this.paymentStatus == 'Order Failed' &&
          this.paymentStatus2 == 'Item Error'
        ) {
          this.checkSoldOutItem()
        }
      } else if (this.paymentStatus == 'Order Successful') {
        sessionStorage.setItem('haveRefId', 0)
        // console.log(this.successLogin)

        var backEndMode = sessionStorage.getItem('backEndAddOrd')
        if (backEndMode == 'true') {
          sessionStorage.removeItem('TotalCartItemQty')
          sessionStorage.removeItem('cart')
          sessionStorage.removeItem('sltCatName')

          if (globalVar.mode == 'normal') {
            this.$router.replace('/Backend')
          } else if (globalVar.mode == 'lite') {
            var mchCd = sessionStorage.getItem('paramMchdCode')
            this.$router.replace({
              name: 'Backend',
              params: { mchdCode: mchCd }
            })
          }
        } else {
          if (this.successLogin) {
            const tokenKey = sessionStorage.getItem('LoginToken')

            //clear all
            // this.$session.clear()
            // sessionStorage.clear()

            //open new
            sessionStorage.setItem('LoginToken', tokenKey)
            // sessionStorage.setItem(
            //   'successLogin',
            //   JSON.stringify({
            //     successLogin: true,
            //     clientDisplayName: response.data.ez,
            //     clientMobileNo: response.data.az,
            //     clientAddress: response.data.en,
            //     clientId: response.data.m,
            //     clientEmail: response.data.ly,
            //     clientBalancePoint: response.data.re
            //   })
            // )
            sessionStorage.setItem('checkOutBackToSearch', true)

            if (globalVar.mode == 'normal') {
              this.$router.replace('/')
            } else if (globalVar.mode == 'lite') {
              var mchCd2 = sessionStorage.getItem('paramMchdCode')
              this.$router.replace({
                name: 'Search',
                params: { mchdCode: mchCd2 }
              })
            }
          } else {
            //clear all
            // this.$session.clear()
            // sessionStorage.clear()

            //open new
            sessionStorage.setItem(
              'successLogin',
              JSON.stringify({
                successLogin: false
              })
            )

            if (globalVar.mode == 'normal') {
              this.$router.replace('/')
            } else if (globalVar.mode == 'lite') {
              var mchCd3 = sessionStorage.getItem('paramMchdCode')
              this.$router.replace({
                name: 'Search',
                params: { mchdCode: mchCd3 }
              })
            }
          }
        }
      }
    },
    // backToMainlistButton() {
    //   const currentURL = this.$router.currentRoute.fullPath
    //   // console.log('url', currentURL)
    //   if (currentURL === '/shopping-cart') {
    //     this.$router.replace('/mainlist')
    //   }
    // },
    backToPrevPage() {
      const value = sessionStorage.getItem('afterViewPH')
      console.log(value)
      const viewSCFrom = sessionStorage.getItem('viewShoppingCart')
      var viewSCFromValue = JSON.parse(viewSCFrom)
      console.log(viewSCFromValue)
      if (value == 'fromShoppingCart') {
        if (viewSCFromValue.status == 'fromMainlist') {
          sessionStorage.setItem('needBackPrevPosition', true)

          if (globalVar.mode == 'normal') {
            this.$router.replace('/mainlist')
          } else if (globalVar.mode == 'lite') {
            var mchCd = sessionStorage.getItem('paramMchdCode')
            this.$router.replace({
              name: 'MainList',
              params: { mchdCode: mchCd }
            })
          }
        } else if (viewSCFromValue.status == 'fromItemDetail') {
          if (globalVar.mode == 'normal') {
            this.$router.replace({
              name: 'ItemDetail',
              params: { itemId: viewSCFromValue.itemId }
            })
          } else if (globalVar.mode == 'lite') {
            var mchCd4 = sessionStorage.getItem('paramMchdCode')
            this.$router.replace({
              name: 'ItemDetail',
              params: { mchdCode: mchCd4, itemId: viewSCFromValue.itemId }
            })
          }
        }
      } else {
        if (viewSCFromValue.status == 'fromMainlist') {
          sessionStorage.setItem('needBackPrevPosition', true)

          if (globalVar.mode == 'normal') {
            this.$router.replace('/mainlist')
          } else if (globalVar.mode == 'lite') {
            var mchCd2 = sessionStorage.getItem('paramMchdCode')
            this.$router.replace({
              name: 'MainList',
              params: { mchdCode: mchCd2 }
            })
          }
        } else if (viewSCFromValue.status == 'fromItemDetail') {
          if (globalVar.mode == 'normal') {
            this.$router.replace({
              name: 'ItemDetail',
              params: { itemId: viewSCFromValue.itemId }
            })
          } else if (globalVar.mode == 'lite') {
            var mchCd3 = sessionStorage.getItem('paramMchdCode')
            this.$router.replace({
              name: 'ItemDetail',
              params: { mchdCode: mchCd3, itemId: viewSCFromValue.itemId }
            })
          }
        }
      }
    },
    viewPurchaseHistory() {
      sessionStorage.setItem('viewPurchaseHistory', 'fromShoppingCart')

      if (globalVar.mode == 'normal') {
        this.$router.replace('/PurchaseHistory')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({
          name: 'PurchaseHistory',
          params: { mchdCode: mchCd }
        })
      }
    },
    backToBackEndOrd() {
      sessionStorage.removeItem('TotalCartItemQty')
      sessionStorage.removeItem('cart')
      sessionStorage.removeItem('sltCatName')

      if (globalVar.mode == 'normal') {
        this.$router.replace('/Backend')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({ name: 'Backend', params: { mchdCode: mchCd } })
      }
    }
  }
}
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='Number'] {
  -moz-appearance: textfield;
}

.spanTxtStyle {
  float: right;
  min-width: 25%;
  text-align: right;
  margin-right: 10px;
}

.smallFontSize {
  font-size: 18px;
}

.iPrice {
  width: var(--shoppingCart-iPrice-width);
  padding-left: var(--shoppingCart-iPrice-padding_left);
  padding-right: var(--shoppingCart-iPrice-padding_right);
}

.border {
  padding: var(--shoppingCart-border-padding);
  border: var(--shoppingCart-border-border);
  border-radius: var(--shoppingCart-border-border_radius);
}

h2 {
  font: var(--shoppingCart-h2-font);
}

.txtClrRed {
  /* color: var(--shoppingCart-txtClrRed-color); */
  color: red;
}

.vl {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  border: 2px solid gainsboro;
  width: 90%;
}

.vl-innertext {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: gainsboro;
  border: 1px solid gainsboro;
  border-radius: 50%;
  padding: 8px 10px;
}

.progress-circular {
  margin: auto;
  position: absolute;
  top: 20%;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 20px;
}

.loadingMsg {
  text-align: center;
  font-size: 18px;
}
.guestTxt {
  font-size: 18px !important;
  width: 45%;
  height: 40px;
  margin: 10px;
  padding: 0px;
}
.TrnHdrTbNum {
  font-size: 20px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 30%;
}
.TrnHdrTbNumInput {
  width: 70%;
}
@media (max-width: 769px) {
  .TrnHdrTbNum {
    font-size: 20px;
    margin-top: 5px;
    margin-bottom: 5px;
    width: 40%;
  }
  .TrnHdrTbNumInput {
    width: 60%;
  }
}
@media (max-width: 549px) {
  .TrnHdrTbNum {
    font-size: 20px;
    margin-top: 5px;
    margin-bottom: 5px;
    width: 50%;
  }
  .TrnHdrTbNumInput {
    width: 50%;
  }
}
@media (max-width: 491px) {
  .TrnHdrTbNum {
    font-size: 18px;
    margin-top: 5px;
    margin-bottom: 5px;
    width: 50%;
  }
}
@media (max-width: 450px) {
  .guestTxt {
    font-size: 15px !important;
  }
  .smallFontSize {
    font-size: 15px;
  }
}
@media (max-width: 448px) {
  .TrnHdrTbNum {
    font-size: 18px;
    margin-top: 5px;
    margin-bottom: 5px;
    width: 50% !important;
  }
  .TrnHdrTbNumInput {
    width: 50% !important;
  }
}

@media (max-width: 400px) {
  .loadingMsg {
    font-size: 15px;
  }

  .userProfileTxt {
    margin: 0px;
  }
}
@media (max-width: 350px) {
  .smallFontSize {
    font-size: 14px;
  }
}
@media (max-width: 300px) {
  .guestTxt {
    font-size: 12px !important;
  }
}
@media (max-width: 260px) {
  .guestTxt {
    font-size: 10px !important;
  }
}
</style>
